export const PAGE_CONFIG = {
  "name": "CommonHeader",
  "isRender": true,
  "data": {
    "subtitle": "-"
  },
  "config": {
    "title": "周DAU 异动分析",
    "titleCn": "周DAU 异动分析",
    "subtitle": "Last Updated : {{subtitle}}",
    "subtitleCn": "Last Updated : {{subtitle}}",
    "customSubTitle": true
  },
  "children": [
    {
      "name": "CommonContantWrap",
      "config": {
        "isHaveNotification": true,
        "notificationPath": "/changeAnalysis",
        "logConfig": {
          "typeId": "dashboard_pc_v2",
          "uidType": "game_code",
          "pageId": "206601",
          "pageName": "ChangeAnalysis",
          "extInfo": "ChangeAnalysis",
          "pagePath": "/changeAnalysis"
        }
      },
      "children": [
        {
          "name": "CommonRangePicker",
          "props": {
            "granularity": "week",
            "singleWeek": true,
            "timeZone": -8,
            "minDate": "2025-09-07"
          },
          "children": [
            {
              "name": "Service",
              "props": {
                "api": "/api/v1/dashboard/weekly_analysis/detail",
                "dataKey": "ai_summary",
                "trackData": [
                  "extraParams",
                  "gameCode"
                ],
                "beforeRequest": "function(data) {\n                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                    return Object.assign({\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date,\n                                        logical_flag: \"ai分析总结\"\n                                    }, data.extraParams);\n                                }",
                "formatData": "function(data) {\n                                    return data === null || data === void 0 ? void 0 : data[0];\n                                }"
              },
              "children": [
                {
                  "name": "MarkDownCard",
                  "className": "margin-t-20 dbd-markdown-card-title-black",
                  "props": {
                    "titleEn": "AI分析总结",
                    "titleCn": "AI分析总结",
                    "titleIcon": "ai-color-robot",
                    "content": "{{data.info_detail}}",
                    "updateDate": "{{data.dtstatdate}}",
                    "infoType": "{{data.info_type}}",
                    "linkOpenInNewWindow": true
                  }
                }
              ]
            },
            {
              "name": "RadioSwitch",
              "className": "margin-t-20",
              "data": {
                "alignment": "version_aligned"
              },
              "props": {
                "config": {
                  "dataKey": "alignment",
                  "options": [
                    {
                      "value": "version_aligned",
                      "name": "版本周对齐",
                      "nameCn": "版本周对齐"
                    },
                    {
                      "value": "natural_day_aligned",
                      "name": "自然日对齐",
                      "nameCn": "自然日对齐"
                    }
                  ]
                }
              },
              "children": [
                {
                  "name": "Service",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/card_metrics",
                    "dataKey": "card_data",
                    "trackData": [
                      "extraParams",
                      "gameCode"
                    ],
                    "beforeRequest": "function(data) {\n                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                    return Object.assign({\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date,\n                                        logical_flag: \"ziyingqu\",\n                                        period: period\n                                    }, data.extraParams || {});\n                                }",
                    "formatData": "function(data) {\n                                    var card_data = data.card_data, trend_dau_data = data.trend_dau_data;\n                                    var formatDate = function(str) {\n                                        if (!str) return '';\n                                        return \"\".concat(str.slice(0, 4), \"-\").concat(str.slice(4, 6), \"-\").concat(str.slice(6, 8));\n                                    };\n                                    var start = formatDate(card_data.week_start);\n                                    var end = formatDate(card_data.week_end);\n                                    var lastWeekStart = formatDate(card_data.last_week_start);\n                                    var lastWeekEnd = formatDate(card_data.last_week_end);\n                                    var lastYearStart = formatDate(card_data.last_year_start);\n                                    var lastYearEnd = formatDate(card_data.last_year_end);\n                                    var lastYearVersionStart = formatDate(card_data.last_year_version_start);\n                                    var lastYearVersionEnd = formatDate(card_data.last_year_version_end);\n                                    var cardData = Object.assign({\n                                        thisTime: \"\".concat(start, \" ~ \").concat(end),\n                                        lastTimeWeek: \"\".concat(lastWeekStart, \" ~ \").concat(lastWeekEnd),\n                                        lastTimeYear: \"\".concat(lastYearStart, \" ~ \").concat(lastYearEnd),\n                                        lastTimeVersionYear: \"\".concat(lastYearVersionStart, \" ~ \").concat(lastYearVersionEnd)\n                                    }, card_data);\n                                    return {\n                                        card_data: cardData,\n                                        trend_dau_data: trend_dau_data\n                                    };\n                                }"
                  },
                  "children": [
                    {
                      "name": "CardState",
                      "style": {
                        "height": "146px"
                      },
                      "props": {
                        "apiGroup": [
                          "card_data"
                        ]
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "style": {
                            "marginBottom": "-20px"
                          },
                          "children": [
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 9,
                                "style": {
                                  "width": "34%",
                                  "flex": 1
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "titleEn": "自营区周日均DAU",
                                    "titleCn": "自营区周日均DAU",
                                    "metricKey": "avg_dau",
                                    "formatRule": "thousandsInit",
                                    "bubbleTitleEn": "DAU",
                                    "bubbleTitleCn": "DAU",
                                    "alignmentConfig": {
                                      "version_aligned": {
                                        "trendConfig": {
                                          "formatRule": "thousandsInit",
                                          "isCompare": true,
                                          "nameEn": "当前",
                                          "nameCn": "当前",
                                          "metricKey": "dau",
                                          "compareToolTipNameEn": "上周",
                                          "compareToolTipNameCn": "上周",
                                          "compareKey": "last_week_dau",
                                          "legendConfig": [
                                            { "nameEn": "当前", "nameCn": "当前", "color": "#1677FF" },
                                            { "nameEn": "上周", "nameCn": "上周", "color": "#52C41A" },
                                            { "nameEn": "去年版本", "nameCn": "去年版本", "color": "#F8D74D" }
                                          ],
                                          "additionalSeries": [
                                            {
                                              "seriesKey": "last_year_version_dau",
                                              "nameEn": "去年版本",
                                              "nameCn": "去年版本",
                                              "toolTipNameEn": "去年版本",
                                              "toolTipNameCn": "去年版本",
                                              "lineStyle": { "type": "dotted" },
                                              "color": "#F8D74D",
                                              "areaStyle": { "color": "#F8D74D", "opacity": 0.25 }
                                            }
                                          ]
                                        }
                                      },
                                      "natural_day_aligned": {
                                        "trendConfig": {
                                          "formatRule": "thousandsInit",
                                          "isCompare": true,
                                          "nameEn": "当前",
                                          "nameCn": "当前",
                                          "metricKey": "dau",
                                          "compareToolTipNameEn": "上周",
                                          "compareToolTipNameCn": "上周",
                                          "compareKey": "last_week_dau",
                                          "legendConfig": [
                                            { "nameEn": "当前", "nameCn": "当前", "color": "#1677FF" },
                                            { "nameEn": "上周", "nameCn": "上周", "color": "#52C41A" },
                                            { "nameEn": "去年同期", "nameCn": "去年同期", "color": "#F8D74D" }
                                          ],
                                          "additionalSeries": [
                                            {
                                              "seriesKey": "last_year_dau",
                                              "nameEn": "去年同期",
                                              "nameCn": "去年同期",
                                              "toolTipNameEn": "去年同期",
                                              "toolTipNameCn": "去年同期",
                                              "lineStyle": { "type": "dotted" },
                                              "color": "#F8D74D",
                                              "areaStyle": { "color": "#F8D74D", "opacity": 0.25 }
                                            }
                                          ]
                                        }
                                      }
                                    },
                                    "trendConfig": {
                                      "formatRule": "thousandsInit",
                                      "isCompare": true,
                                      "nameEn": "当前",
                                      "nameCn": "当前",
                                      "metricKey": "dau",
                                      "compareToolTipNameEn": "上周",
                                      "compareToolTipNameCn": "上周",
                                      "compareKey": "last_week_dau",
                                      "legendConfig": [
                                        {
                                          "nameEn": "当前",
                                          "nameCn": "当前",
                                          "color": "#1677FF"
                                        },
                                        {
                                          "nameEn": "上周",
                                          "nameCn": "上周",
                                          "color": "#52C41A"
                                        },
                                        {
                                          "nameEn": "去年版本",
                                          "nameCn": "去年版本",
                                          "color": "#F8D74D"
                                        }
                                      ],
                                      "additionalSeries": [
                                        {
                                          "seriesKey": "last_year_version_dau",
                                          "nameEn": "去年版本",
                                          "nameCn": "去年版本",
                                          "toolTipNameEn": "去年版本",
                                          "toolTipNameCn": "去年版本",
                                          "lineStyle": {
                                            "type": "dotted"
                                          },
                                          "color": "#F8D74D",
                                          "areaStyle": {
                                            "color": "#F8D74D",
                                            "opacity": 0.25
                                          }
                                        }
                                      ]
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 5,
                                "style": {
                                  "width": "22%"
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "titleEn": "DAU环比变化率(VS 上周)",
                                    "titleCn": "DAU环比变化率(VS 上周)",
                                    "metricKey": "dau_wow_rate",
                                    "formatRule": "percent1Decimal",
                                    "icon": "user-success",
                                    "showArrowIcon": true,
                                    "showValueColor": true,
                                    "dodConfig": [
                                      {
                                        "titleEn": "变化量",
                                        "titleCn": "变化量",
                                        "formatRule": "thousandsInit",
                                        "hideDodIcon": true,
                                        "metricKey": "dau_wow_change",
                                        "showPlusIcon": true
                                      }
                                    ],
                                    "dodDataMap": {
                                      "thisValue": "avg_dau",
                                      "lastValue": "last_week_avg_dau",
                                      "thisTime": "thisTime",
                                      "lastTime": "lastTimeWeek"
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 5,
                                "style": {
                                  "width": "24%"
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "titleEn": "DAU同比变化率(VS 去年版本)",
                                    "titleCn": "DAU同比变化率(VS 去年版本)",
                                    "metricKey": "dau_yoy_version_rate",
                                    "formatRule": "percent1Decimal",
                                    "icon": "user-success",
                                    "showArrowIcon": true,
                                    "showValueColor": true,
                                    "alignmentConfig": {
                                      "version_aligned": {
                                        "titleEn": "DAU同比变化率(VS 去年版本)",
                                        "titleCn": "DAU同比变化率(VS 去年版本)",
                                        "metricKey": "dau_yoy_version_rate",
                                        "dodConfig": [
                                          {
                                            "metricKey": "dau_yoy_version_change",
                                            "titleEn": "变化量",
                                            "titleCn": "变化量",
                                            "formatRule": "thousandsInit",
                                            "hideDodIcon": true,
                                            "showPlusIcon": true
                                          }
                                        ],
                                        "dodDataMap": {
                                          "thisValue": "avg_dau",
                                          "lastValue": "last_year_version_avg_dau",
                                          "thisTime": "thisTime",
                                          "lastTime": "lastTimeVersionYear"
                                        }
                                      },
                                      "natural_day_aligned": {
                                        "titleEn": "DAU同比变化率(VS 去年同期)",
                                        "titleCn": "DAU同比变化率(VS 去年同期)",
                                        "metricKey": "dau_yoy_rate",
                                        "dodConfig": [
                                          {
                                            "metricKey": "dau_yoy_change",
                                            "titleEn": "变化量",
                                            "titleCn": "变化量",
                                            "formatRule": "thousandsInit",
                                            "hideDodIcon": true,
                                            "showPlusIcon": true
                                          }
                                        ],
                                        "dodDataMap": {
                                          "thisValue": "avg_dau",
                                          "lastValue": "last_year_avg_dau",
                                          "thisTime": "thisTime",
                                          "lastTime": "lastTimeYear"
                                        }
                                      }
                                    },
                                    "dodConfig": [
                                      {
                                        "metricKey": "dau_yoy_version_change",
                                        "titleEn": "变化量",
                                        "titleCn": "变化量",
                                        "formatRule": "thousandsInit",
                                        "hideDodIcon": true,
                                        "showPlusIcon": true
                                      }
                                    ],
                                    "dodDataMap": {
                                      "thisValue": "avg_dau",
                                      "lastValue": "last_year_version_avg_dau",
                                      "thisTime": "thisTime",
                                      "lastTime": "lastTimeVersionYear"
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 5,
                                "style": {
                                  "width": "19%"
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "titleEn": "自营区WAU",
                                    "titleCn": "自营区WAU",
                                    "metricKey": "wau",
                                    "formatRule": "thousandsInit",
                                    "icon": "user-success",
                                    "dodConfig": [
                                      {
                                        "metricKey": "wau_wow_rate",
                                        "titleEn": "环比",
                                        "titleCn": "环比",
                                        "formatRule": "percent1Decimal",
                                        "hideDodIcon": true,
                                        "showPlusIcon": true
                                      }
                                    ],
                                    "dodDataMap": {
                                      "thisValue": "wau",
                                      "lastValue": "last_week_wau",
                                      "thisTime": "thisTime",
                                      "lastTime": "lastTimeWeek"
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/card_metrics",
                    "dataKey": "card_data",
                    "trackData": [
                      "extraParams",
                      "gameCode"
                    ],
                    "beforeRequest": "function(data) {\n                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                    return Object.assign({\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date,\n                                        period: period\n                                    }, data.extraParams);\n                                }",
                    "formatData": "function(data) {\n                                    var card_data = data.card_data, trend_dau_data = data.trend_dau_data;\n                                    var formatDate = function(str) {\n                                        if (!str) return '';\n                                        return \"\".concat(str.slice(0, 4), \"-\").concat(str.slice(4, 6), \"-\").concat(str.slice(6, 8));\n                                    };\n                                    var start = formatDate(card_data.week_start);\n                                    var end = formatDate(card_data.week_end);\n                                    var lastWeekStart = formatDate(card_data.last_week_start);\n                                    var lastWeekEnd = formatDate(card_data.last_week_end);\n                                    var lastYearStart = formatDate(card_data.last_year_start);\n                                    var lastYearEnd = formatDate(card_data.last_year_end);\n                                    var lastYearVersionStart = formatDate(card_data.last_year_version_start);\n                                    var lastYearVersionEnd = formatDate(card_data.last_year_version_end);\n                                    var cardData = Object.assign({\n                                        thisTime: \"\".concat(start, \" ~ \").concat(end),\n                                        lastTimeWeek: \"\".concat(lastWeekStart, \" ~ \").concat(lastWeekEnd),\n                                        lastTimeYear: \"\".concat(lastYearStart, \" ~ \").concat(lastYearEnd),\n                                        lastTimeVersionYear: \"\".concat(lastYearVersionStart, \" ~ \").concat(lastYearVersionEnd)\n                                    }, card_data);\n                                    return {\n                                        card_data: cardData,\n                                        trend_dau_data: trend_dau_data\n                                    };\n                                }"
                  },
                  "children": [
                    {
                      "name": "CardState",
                      "className": "margin-t-20",
                      "style": {
                        "height": "146px"
                      },
                      "props": {
                        "apiGroup": [
                          "card_data"
                        ]
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "children": [
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 9,
                                "style": {
                                  "width": "34%",
                                  "flex": 1
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "titleEn": "非简中周日均DAU",
                                    "titleCn": "非简中周日均DAU",
                                    "metricKey": "avg_dau",
                                    "formatRule": "thousandsInit",
                                    "bubbleTitleEn": "DAU",
                                    "bubbleTitleCn": "DAU",
                                    "alignmentConfig": {
                                      "version_aligned": {
                                        "trendConfig": {
                                          "formatRule": "thousandsInit",
                                          "isCompare": true,
                                          "nameEn": "当前",
                                          "nameCn": "当前",
                                          "metricKey": "dau",
                                          "compareToolTipNameEn": "上周",
                                          "compareToolTipNameCn": "上周",
                                          "compareKey": "last_week_dau",
                                          "legendConfig": [
                                            { "nameEn": "当前", "nameCn": "当前", "color": "#1677FF" },
                                            { "nameEn": "上周", "nameCn": "上周", "color": "#52C41A" },
                                            { "nameEn": "去年版本", "nameCn": "去年版本", "color": "#F8D74D" }
                                          ],
                                          "additionalSeries": [
                                            {
                                              "seriesKey": "last_year_version_dau",
                                              "nameEn": "去年版本",
                                              "nameCn": "去年版本",
                                              "toolTipNameEn": "去年版本",
                                              "toolTipNameCn": "去年版本",
                                              "lineStyle": { "type": "dotted" },
                                              "color": "#F8D74D",
                                              "areaStyle": { "color": "#F8D74D", "opacity": 0.25 }
                                            }
                                          ]
                                        }
                                      },
                                      "natural_day_aligned": {
                                        "trendConfig": {
                                          "formatRule": "thousandsInit",
                                          "isCompare": true,
                                          "nameEn": "当前",
                                          "nameCn": "当前",
                                          "metricKey": "dau",
                                          "compareToolTipNameEn": "上周",
                                          "compareToolTipNameCn": "上周",
                                          "compareKey": "last_week_dau",
                                          "legendConfig": [
                                            { "nameEn": "当前", "nameCn": "当前", "color": "#1677FF" },
                                            { "nameEn": "上周", "nameCn": "上周", "color": "#52C41A" },
                                            { "nameEn": "去年同期", "nameCn": "去年同期", "color": "#F8D74D" }
                                          ],
                                          "additionalSeries": [
                                            {
                                              "seriesKey": "last_year_dau",
                                              "nameEn": "去年同期",
                                              "nameCn": "去年同期",
                                              "toolTipNameEn": "去年同期",
                                              "toolTipNameCn": "去年同期",
                                              "lineStyle": { "type": "dotted" },
                                              "color": "#F8D74D",
                                              "areaStyle": { "color": "#F8D74D", "opacity": 0.25 }
                                            }
                                          ]
                                        }
                                      }
                                    },
                                    "trendConfig": {
                                      "formatRule": "thousandsInit",
                                      "isCompare": true,
                                      "nameEn": "当前",
                                      "nameCn": "当前",
                                      "metricKey": "dau",
                                      "compareToolTipNameEn": "上周",
                                      "compareToolTipNameCn": "上周",
                                      "compareKey": "last_week_dau",
                                      "legendConfig": [
                                        {
                                          "nameEn": "当前",
                                          "nameCn": "当前",
                                          "color": "#1677FF"
                                        },
                                        {
                                          "nameEn": "上周",
                                          "nameCn": "上周",
                                          "color": "#52C41A"
                                        },
                                        {
                                          "nameEn": "去年版本",
                                          "nameCn": "去年版本",
                                          "color": "#F8D74D"
                                        }
                                      ],
                                      "additionalSeries": [
                                        {
                                          "seriesKey": "last_year_version_dau",
                                          "nameEn": "去年版本",
                                          "nameCn": "去年版本",
                                          "toolTipNameEn": "去年版本",
                                          "toolTipNameCn": "去年版本",
                                          "lineStyle": {
                                            "type": "dotted"
                                          },
                                          "color": "#F8D74D",
                                          "areaStyle": {
                                            "color": "#F8D74D",
                                            "opacity": 0.25
                                          }
                                        }
                                      ]
                                    },
                                    "lineSeries": [
                                      {
                                        "name": "DAU",
                                        "data": [
                                          100,
                                          200,
                                          300
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 5,
                                "style": {
                                  "width": "22%"
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "titleEn": "DAU环比变化率(VS 上周)",
                                    "titleCn": "DAU环比变化率(VS 上周)",
                                    "formatRule": "percent1Decimal",
                                    "metricKey": "dau_wow_rate",
                                    "icon": "user-success",
                                    "showArrowIcon": true,
                                    "showValueColor": true,
                                    "dodConfig": [
                                      {
                                        "metricKey": "dau_wow_change",
                                        "titleEn": "变化量",
                                        "titleCn": "变化量",
                                        "formatRule": "thousandsInit",
                                        "hideDodIcon": true,
                                        "showPlusIcon": true
                                      }
                                    ],
                                    "dodDataMap": {
                                      "thisValue": "avg_dau",
                                      "lastValue": "last_week_avg_dau",
                                      "thisTime": "thisTime",
                                      "lastTime": "lastTimeWeek"
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 5,
                                "style": {
                                  "width": "24%"
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "titleEn": "DAU同比变化率(VS 去年版本)",
                                    "titleCn": "DAU同比变化率(VS 去年版本)",
                                    "metricKey": "dau_yoy_version_rate",
                                    "formatRule": "percent1Decimal",
                                    "icon": "user-success",
                                    "showArrowIcon": true,
                                    "showValueColor": true,
                                    "alignmentConfig": {
                                      "version_aligned": {
                                        "titleEn": "DAU同比变化率(VS 去年版本)",
                                        "titleCn": "DAU同比变化率(VS 去年版本)",
                                        "metricKey": "dau_yoy_version_rate",
                                        "dodConfig": [
                                          {
                                            "metricKey": "dau_yoy_version_change",
                                            "titleEn": "变化量",
                                            "titleCn": "变化量",
                                            "formatRule": "thousandsInit",
                                            "hideDodIcon": true,
                                            "showPlusIcon": true
                                          }
                                        ],
                                        "dodDataMap": {
                                          "thisValue": "avg_dau",
                                          "lastValue": "last_year_version_avg_dau",
                                          "thisTime": "thisTime",
                                          "lastTime": "lastTimeVersionYear"
                                        }
                                      },
                                      "natural_day_aligned": {
                                        "titleEn": "DAU同比变化率(VS 去年同期)",
                                        "titleCn": "DAU同比变化率(VS 去年同期)",
                                        "metricKey": "dau_yoy_rate",
                                        "dodConfig": [
                                          {
                                            "metricKey": "dau_yoy_change",
                                            "titleEn": "变化量",
                                            "titleCn": "变化量",
                                            "formatRule": "thousandsInit",
                                            "hideDodIcon": true,
                                            "showPlusIcon": true
                                          }
                                        ],
                                        "dodDataMap": {
                                          "thisValue": "avg_dau",
                                          "lastValue": "last_year_avg_dau",
                                          "thisTime": "thisTime",
                                          "lastTime": "lastTimeYear"
                                        }
                                      }
                                    },
                                    "dodConfig": [
                                      {
                                        "metricKey": "dau_yoy_version_change",
                                        "titleEn": "变化量",
                                        "titleCn": "变化量",
                                        "formatRule": "thousandsInit",
                                        "hideDodIcon": true,
                                        "showPlusIcon": true
                                      }
                                    ],
                                    "dodDataMap": {
                                      "thisValue": "avg_dau",
                                      "lastValue": "last_year_version_avg_dau",
                                      "thisTime": "thisTime",
                                      "lastTime": "lastTimeVersionYear"
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "props": {
                                "w": 5,
                                "style": {
                                  "width": "19%"
                                }
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisTrendCard",
                                  "props": {
                                    "metricKey": "wau",
                                    "titleEn": "非简中WAU",
                                    "titleCn": "非简中WAU",
                                    "formatRule": "thousandsInit",
                                    "icon": "user-success",
                                    "dodConfig": [
                                      {
                                        "metricKey": "wau_wow_rate",
                                        "titleEn": "环比",
                                        "titleCn": "环比",
                                        "formatRule": "percent1Decimal",
                                        "hideDodIcon": true,
                                        "showPlusIcon": true
                                      }
                                    ],
                                    "dodDataMap": {
                                      "thisValue": "wau",
                                      "lastValue": "last_week_wau",
                                      "thisTime": "thisTime",
                                      "lastTime": "lastTimeWeek"
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "Service",
              "props": {
                "api": "/api/v1/dashboard/weekly_analysis/version_compare_table",
                "trackData": [
                  "extraParams",
                  "gameCode"
                ],
                "dataKey": "versionCompareTableData",
                "rawData": true,
                "beforeRequest": "function(data) {\n                                    var filter = (data === null || data === void 0 ? void 0 : data.filterVal) || {};\n                                    var start_date = filter.start_date;\n                                    var end_date = filter.end_date;\n                                    var result = {\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date\n                                    };\n                                    if (data === null || data === void 0 ? void 0 : data.extraParams) {\n                                        Object.assign(result, data.extraParams);\n                                    }\n                                    return result;\n                                }",
                "formatData": "function(data) {\n                                    if (!Array.isArray(data)) return {};\n                                    return data.map(function(item) {\n                                        return Object.assign({}, item, {\n                                            id: \"\".concat(item.dtstatdate, \"_\").concat(item.compare_type),\n                                            date: item.dtstatdate,\n                                            is_increase: item.is_increase ? '上升' : '下降'\n                                        });\n                                    });\n                                }"
              },
              "children": [
                {
                  "name": "Service",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/key_metrics_table",
                    "trackData": [
                      "extraParams",
                      "gameCode"
                    ],
                    "dataKey": "keyMetricsTableData",
                    "rawData": true,
                    "beforeRequest": "function(data) {\n                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                    return Object.assign({\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date\n                                    }, data.extraParams);\n                                }",
                    "formatData": "function(data) {\n                                    if (!Array.isArray(data)) return {};\n                                    return data === null || data === void 0 ? void 0 : data.map(function(item) {\n                                        return Object.assign({}, item, {\n                                            id: \"\".concat(item.dtstatdate, \"_\").concat(item.compare_type),\n                                            date: item.dtstatdate\n                                        });\n                                    });\n                                }"
                  },
                  "children": [
                    {
                      "name": "ChangeAnalysisAiTable",
                      "className": "margin-t-20",
                      "props": {
                        "config": {
                          "titleEn": "非简中关键指标变化",
                          "titleCn": "非简中关键指标变化",
                          "downloadFileNameEn": "非简中关键指标变化",
                          "downloadFileNameCn": "非简中关键指标变化",
                          "aiConfig": [
                            {
                              "tag": "key_metrics_change_trend",
                              "dataKey": "keyMetricsTableData",
                              "alignmentTagMap": {
                                "version_aligned": "key_metrics_change_trend",
                                "natural_day_aligned": "key_metrics_change_trend_natural"
                              },
                              "enableAlignmentAiDataKey": true
                            },
                            {
                              "tag": "version_metrics_table",
                              "dataKey": "versionCompareTableData",
                              "alignmentTagMap": {
                                "version_aligned": "version_metrics_table",
                                "natural_day_aligned": "version_metrics_table_natural"
                              },
                              "enableAlignmentAiDataKey": true
                            }
                          ],
                          "alignmentSwitchConfig": {
                            "defaultValue": "version_aligned",
                            "options": [
                              {
                                "value": "version_aligned",
                                "name": "版本周对齐",
                                "nameCn": "版本周对齐"
                              },
                              {
                                "value": "natural_day_aligned",
                                "name": "自然日对齐",
                                "nameCn": "自然日对齐"
                              }
                            ]
                          },
                          "trendTableColumnSwitch": {
                            "dataKey": "keyMetricsTableData",
                            "targetColumnCode": "dau_yoy_rate",
                            "version_aligned": {
                              "nameEn": "版本年同比",
                              "nameCn": "版本年同比",
                              "code": "dau_yoy_version_rate"
                            },
                            "natural_day_aligned": {
                              "nameEn": "年同比",
                              "nameCn": "年同比",
                              "code": "dau_yoy_rate"
                            }
                          }
                        }
                      },
                      "children": [
                        {
                          "name": "CommonTable",
                          "className": "dbd-common-table--in-card",
                          "props": {
                            "dataKey": "versionCompareTableData",
                            "metricsCardWrapProps": {
                              "titleEn": "关键指标变化",
                              "titleCn": "关键指标变化"
                            },
                            "commonBaseTableProps": {
                              "height": 300,
                              "columns": [
                                {
                                  "nameEn": "对比基准",
                                  "nameCn": "对比基准",
                                  "code": "date",
                                  "width": 220,
                                  "align": "left",
                                  "lock": true,
                                  "features": {
                                    "cell": {
                                      "type": "date",
                                      "tagKey": "compare_type",
                                      "mergeToMainColumn": true,
                                      "tagKeyConfig": {
                                        "format": "@"
                                      }
                                    },
                                    "format": "day",
                                    "downLoadFormat": "yyyy-mm-dd"
                                  }
                                },
                                {
                                  "name": "周日均DAU",
                                  "code": "version_avg_dau",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                },
                                {
                                  "name": "本周周日均DAU",
                                  "code": "current_avg_dau",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                },
                                {
                                  "name": "变化量",
                                  "code": "change",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                },
                                {
                                  "name": "变化率",
                                  "code": "change_rate",
                                  "width": 195,
                                  "align": "right",
                                  "features": {
                                    "progressBar": {},
                                    "format": "percent1Decimal",
                                    "downLoadFormat": "0.0%",
                                    "cell": {
                                      "showPercentageAsChangeRate": true,
                                      "showProgressBar": true,
                                      "showNegativeSign": false,
                                      "progressBarProps": {
                                        "mode": "center"
                                      }
                                    }
                                  }
                                },
                                {
                                  "name": "变化方向",
                                  "code": "is_increase",
                                  "width": 110,
                                  "align": "left",
                                  "features": {
                                    "format": "thousandsInit",
                                    "cell": {
                                      "type": "trend",
                                      "showPercentageAsChangeRate": true,
                                      "changeAlign": "left",
                                      "trendLabelMap": {
                                        "上升": {
                                          "labelEn": "上升",
                                          "labelCn": "上升",
                                          "status": "up"
                                        },
                                        "下降": {
                                          "labelEn": "下降",
                                          "labelCn": "下降",
                                          "status": "down"
                                        }
                                      }
                                    }
                                  }
                                }
                              ],
                              "tableConfig": {
                                "isShowPagination": false
                              }
                            }
                          }
                        },
                        {
                          "name": "CommonTable",
                          "className": "dbd-common-table--in-card margin-t-20",
                          "props": {
                            "dataKey": "keyMetricsTableData",
                            "metricsCardWrapProps": {
                              "titleEn": "指标变化趋势",
                              "titleCn": "指标变化趋势"
                            },
                            "commonBaseTableProps": {
                              "height": 300,
                              "columns": [
                                {
                                  "name": "日期",
                                  "code": "date",
                                  "width": 220,
                                  "align": "left",
                                  "lock": true,
                                  "features": {
                                    "cell": {
                                      "type": "date",
                                      "tagKey": "compare_type",
                                      "mergeToMainColumn": true,
                                      "tagKeyConfig": {
                                        "format": "@"
                                      }
                                    },
                                    "format": "day",
                                    "downLoadFormat": "yyyy-mm-dd"
                                  }
                                },
                                {
                                  "name": "周日均DAU",
                                  "code": "avg_dau",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                },
                                {
                                  "name": "周环比",
                                  "code": "dau_wow_rate",
                                  "align": "right",
                                  "features": {
                                    "progressBar": {},
                                    "format": "percent1Decimal",
                                    "downLoadFormat": "0.0%",
                                    "cell": {
                                      "showPercentageAsChangeRate": true,
                                      "showProgressBar": true,
                                      "showNegativeSign": false,
                                      "progressBarProps": {
                                        "mode": "center"
                                      }
                                    }
                                  }
                                },
                                {
                                  "name": "去年同期周日均DAU",
                                  "code": "last_year_avg_dau",
                                  "width": 195,
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                },
                                {
                                  "name": "去年同期周环比",
                                  "code": "last_year_wow_rate",
                                  "align": "right",
                                  "features": {
                                    "format": "percent1Decimal",
                                    "downLoadFormat": "0.0%",
                                    "cell": {
                                      "showPercentageAsChangeRate": true,
                                      "showProgressBar": true,
                                      "showNegativeSign": false,
                                      "progressBarProps": {
                                        "mode": "center"
                                      }
                                    }
                                  }
                                },
                                {
                                  "name": "年同比",
                                  "code": "dau_yoy_rate",
                                  "align": "right",
                                  "features": {
                                    "format": "percent1Decimal",
                                    "downLoadFormat": "0.0%",
                                    "cell": {
                                      "showPercentageAsChangeRate": true,
                                      "showProgressBar": true,
                                      "showNegativeSign": false,
                                      "progressBarProps": {
                                        "mode": "center"
                                      }
                                    }
                                  }
                                }
                              ],
                              "tableConfig": {
                                "isShowPagination": false
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "Service",
              "props": {
                "api": "/api/v1/dashboard/weekly_analysis/event_list",
                "trackData": [
                  "extraParams",
                  "gameCode"
                ],
                "dataKey": "eventData",
                "beforeRequest": "function(data) {\n                        var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                        return Object.assign({\n                            game_code: data.gameCode,\n                            start_date: start_date,\n                            end_date: end_date,\n                            period: \"weekly\",\n                            \"logical_flag\": \"last_3_month\"\n                        }, data.extraParams);\n                    }",
                "formatData": "function formatData(data) {\n                                    var event_list = data.event_list, date_map = data.date_map, last_year_date_map = data.last_year_date_map;\n                                    if (!Array.isArray(event_list)) return {};\n                                    var buildEventData = function(dateMapObj) {\n                                        var result = {};\n                                        Object.keys(dateMapObj).forEach(function(key) {\n                                            var mapped = dateMapObj[key];\n                                            var validDates = new Set([\n                                                key,\n                                                mapped\n                                            ]);\n                                            var eventsForThisKey = event_list.filter(function(ev) {\n                                                if (!(ev === null || ev === void 0 ? void 0 : ev.start_time) || !(ev === null || ev === void 0 ? void 0 : ev.end_time)) return false;\n                                                var date = ev.start_time.slice(0, 10).replace(/-/g, \"\");\n                                                return validDates.has(date);\n                                            }).map(function(ev) {\n                                                var event_title_cn = ev.event_title_cn;\n                                                var event_title_en = ev.event_title_en;\n                                                var start_time = ev.start_time;\n                                                var end_time = ev.end_time;\n                                                var desc_cn = \"\".concat(start_time.slice(0, 10), \" ~ \").concat(end_time.slice(0, 10));\n                                                var desc_en = \"\".concat(start_time.slice(0, 10), \" ~ \").concat(end_time.slice(0, 10));\n                                                var newEvent = Object.assign({}, ev);\n                                                delete newEvent.event_title_cn;\n                                                delete newEvent.event_title_en;\n                                                delete newEvent.start_time;\n                                                delete newEvent.end_time;\n                                                return Object.assign(newEvent, {\n                                                    name: event_title_cn,\n                                                    name_cn: event_title_en,\n                                                    event_desc_cn: desc_cn,\n                                                    event_desc_en: desc_en\n                                                });\n                                            });\n                                            if (eventsForThisKey.length > 0) {\n                                                result[key] = eventsForThisKey;\n                                            }\n                                        });\n                                        return result;\n                                    };\n                                    var eventData = buildEventData(date_map);\n                                    var lastEventData = last_year_date_map ? buildEventData(last_year_date_map) : {};\n                                    return {\n                                        eventData: eventData,\n                                        lastEventData: lastEventData,\n                                        rawEventList: event_list\n                                    };\n                                }"
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "margin-t-10",
                  "type": "layout",
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "props": {},
                      "children": [
                        {
                          "name": "Service",
                          "props": {
                            "api": "/api/v1/dashboard/weekly_analysis/metrics_trend",
                            "trackData": [
                              "extraParams",
                              "gameCode"
                            ],
                            "dataKey": "trendData",
                            "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        period: period,\n                                                        logical_flag: \"last_1_year,query_abnormal_data\"\n                                                    }, data.extraParams);\n                                                }",
                            "formatData": "function(data) {\n                                                    var trendData = data === null || data === void 0 ? void 0 : data.trend_dau_data;\n                                                    if (!Array.isArray(trendData)) return {};\n                                                    var formatDate = function(str) {\n                                                        if (!str || str.length !== 8) return str;\n                                                        var year = str.slice(0, 4);\n                                                        var month = str.slice(4, 6);\n                                                        var day = str.slice(6, 8);\n                                                        return \"\".concat(year, \"-\").concat(month, \"-\").concat(day);\n                                                    };\n                                                    return {\n                                                        xAxisData: trendData.map(function(item) {\n                                                            return formatDate(item.date);\n                                                        }),\n                                                        seriesData: trendData.map(function(item) {\n                                                            return Object.assign({}, item, {\n                                                                date: formatDate(item.date)\n                                                            });\n                                                        })\n                                                    };\n                                                }"
                          },
                          "children": [
                            {
                              "name": "EventMetricTrend",
                              "className": "dbd-pubg-dau-change-analysis-trend",
                              "props": {
                                "titleEn": "非简中最近一年DAU趋势",
                                "titleCn": "非简中最近一年DAU趋势",
                                "link": "/dashboard/game/i_game/datalab/customDashboard/DAU%E6%8C%87%E6%A0%87%E5%BC%82%E5%8A%A8%E7%9B%91%E6%8E%A7",
                                "showEventSwitch": false,
                                "defaultShowEvent": false,
                                "subTitle": "红点为系统检测DAU异常日",
                                "seriesConfig": [
                                  {
                                    "metricKey": "dau",
                                    "cnName": "DAU",
                                    "enName": "DAU",
                                    "color": "#5086F3",
                                    "formatRule": "thousandsInit",
                                    "dateKey": "date",
                                    "abnormalSymbolColor": "#EF5858"
                                  }
                                ],
                                "chartConfig": {
                                  "yAxisFormat": "bmk",
                                  "interval": 5000000,
                                  "formatRule": "thousandsInit",
                                  "dateFormatRule": "MM-DD"
                                },
                                "downloadConfig": {
                                  "columns": [
                                    {
                                      "code": "date",
                                      "name": "日期",
                                      "format": "yyyy-mm-dd"
                                    },
                                    {
                                      "code": "dau",
                                      "name": "DAU",
                                      "format": "#,##0"
                                    },
                                    {
                                      "code": "is_abnormal",
                                      "name": "是否异常",
                                      "format": "function(value, _, isEn) {\n                                                                        if (isEn) {\n                                                                            return value ? 'Yes' : 'No';\n                                                                        }\n                                                                        return value ? '是' : '否';\n                                                                    }"
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "props": {},
                      "children": [
                        {
                          "name": "Service",
                          "props": {
                            "api": "/api/v1/dashboard/weekly_analysis/metrics_trend",
                            "trackData": [
                              "extraParams",
                              "gameCode"
                            ],
                            "dataKey": "trendData",
                            "beforeRequest": "function(data) {\n                                                            var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                                            return Object.assign({\n                                                                game_code: data.gameCode,\n                                                                start_date: start_date,\n                                                                end_date: end_date,\n                                                                period: period,\n                                                                logical_flag: \"last_3_month\"\n                                                            }, data.extraParams);\n                                                        }",
                            "formatData": "function(data) {\n                                                            var trendData = data === null || data === void 0 ? void 0 : data.trend_dau_data;\n                                                            if (!Array.isArray(trendData)) return {};\n                                                            var formatDate = function formatDate(str) {\n                                                                if (!str || str.length !== 8) return str;\n                                                                var year = str.slice(0, 4);\n                                                                var month = str.slice(4, 6);\n                                                                var day = str.slice(6, 8);\n                                                                return \"\".concat(year, \"-\").concat(month, \"-\").concat(day);\n                                                            };\n                                                            return {\n                                                                xAxisData: trendData.map(function(item) {\n                                                                    return formatDate(item.date);\n                                                                }),\n                                                                seriesData: trendData.map(function(item) {\n                                                                    return Object.assign({}, item, {\n                                                                        date: formatDate(item.date),\n                                                                        last_year_version_date: formatDate(item.last_year_version_date),\n                                                                        last_year_date: formatDate(item.last_year_date)\n                                                                    });\n                                                                })\n                                                            };\n                                                        }"
                          },
                          "children": [
                            {
                              "name": "EventMetricTrend",
                              "className": "dbd-pubg-dau-version-change-analysis-trend",
                              "props": {
                                "titleEn": "非简中DAU同比趋势图",
                                "titleCn": "非简中DAU同比趋势图",
                                "link": "/dashboard/game/i_game/datalab/customDashboard/DAU%E6%8C%87%E6%A0%87%E5%BC%82%E5%8A%A8%E7%9B%91%E6%8E%A7",
                                "seriesConfig": [
                                  {
                                    "metricKey": "dau",
                                    "cnName": "DAU",
                                    "enName": "DAU",
                                    "color": "#5086F3",
                                    "formatRule": "thousandsInit",
                                    "dateKey": "date"
                                  },
                                  {
                                    "metricKey": "last_year_version_dau",
                                    "cnName": "DAU(去年版本同期)",
                                    "enName": "DAU(去年版本同期)",
                                    "color": "#69D19C",
                                    "formatRule": "thousandsInit",
                                    "dateKey": "last_year_version_date",
                                    "label": {
                                      "show": false
                                    },
                                    "lineStyle": {
                                      "type": "dotted"
                                    }
                                  }
                                ],
                                "radioConfig": {
                                  "targetSeriesIndex": 1,
                                  "defaultValue": "version_aligned",
                                  "options": [
                                    {
                                      "value": "version_aligned",
                                      "labelCn": "版本周对齐",
                                      "labelEn": "版本周对齐",
                                      "metricKey": "last_year_version_dau",
                                      "dateKey": "last_year_version_date",
                                      "cnName": "DAU(去年版本同期)",
                                      "enName": "DAU(去年版本同期)",
                                      "eventDataKey": "eventData"
                                    },
                                    {
                                      "value": "natural_day_aligned",
                                      "labelCn": "自然日对齐",
                                      "labelEn": "自然日对齐",
                                      "metricKey": "last_year_dau",
                                      "dateKey": "last_year_date",
                                      "cnName": "DAU(去年同期)",
                                      "enName": "DAU(去年同期)",
                                      "eventDataKey": "lastEventData"
                                    }
                                  ]
                                },
                                "chartConfig": {
                                  "yAxisFormat": "bmk",
                                  "interval": 5000000,
                                  "formatRule": "thousandsInit",
                                  "dateFormatRule": "MM-DD"
                                },
                                "downloadConfig": {
                                  "columns": [
                                    {
                                      "code": "date",
                                      "name": "日期",
                                      "format": "yyyy-mm-dd",
                                      "type": "date"
                                    },
                                    {
                                      "code": "dau",
                                      "name": "DAU",
                                      "format": "#,##0"
                                    },
                                    {
                                      "code": "event",
                                      "dependKey": "date",
                                      "dateKey": "start_time",
                                      "name": "事件开始时间",
                                      "format": "@",
                                      "type": "event"
                                    },
                                    {
                                      "code": "last_year_version_date",
                                      "name": "去年版本同期日期",
                                      "format": "yyyy-mm-dd",
                                      "type": "date",
                                      "radioValue": "version_aligned"
                                    },
                                    {
                                      "code": "last_year_version_dau",
                                      "name": "DAU(去年版本同期)",
                                      "format": "#,##0",
                                      "radioValue": "version_aligned"
                                    },
                                    {
                                      "code": "last_year_version_event",
                                      "dependKey": "last_year_version_date",
                                      "dateKey": "start_time",
                                      "name": "去年版本同期事件开始时间",
                                      "format": "@",
                                      "type": "event",
                                      "radioValue": "version_aligned"
                                    },
                                    {
                                      "code": "last_year_date",
                                      "name": "去年同期日期",
                                      "format": "yyyy-mm-dd",
                                      "type": "date",
                                      "radioValue": "natural_day_aligned"
                                    },
                                    {
                                      "code": "last_year_dau",
                                      "name": "DAU(去年同期)",
                                      "format": "#,##0",
                                      "radioValue": "natural_day_aligned"
                                    },
                                    {
                                      "code": "last_year_event",
                                      "dependKey": "last_year_date",
                                      "dateKey": "start_time",
                                      "name": "去年同期事件开始时间",
                                      "format": "@",
                                      "type": "event",
                                      "radioValue": "natural_day_aligned"
                                    }
                                  ]
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "extraParams": {
                      "sorted_by": "avg_dau"
                    }
                  },
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/dimension/metrics_trend",
                    "trackData": [
                      "extraParams",
                      "gameCode"
                    ],
                    "dataKey": "trendData",
                    "rawData": true,
                    "beforeRequest": "function(data) {\n                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                    return Object.assign({\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date,\n                                        accumulation: {\n                                            \"by_region\": true\n                                        }\n                                    }, data.extraParams);\n                                }",
                    "formatData": "function(data) {\n                                    if (!Array.isArray(data)) return {};\n                                    var tableData = data === null || data === void 0 ? void 0 : data.map(function(item) {\n                                        return Object.assign({\n                                            id: item === null || item === void 0 ? void 0 : item.dim_code,\n                                            regionNameEn: item.dim_name_en,\n                                            regionNameCn: item.dim_name_cn\n                                        }, item);\n                                    });\n                                    return {\n                                        countryCode: data.map(function(item) {\n                                            return item.dim_code;\n                                        }),\n                                        xData: data.map(function(item) {\n                                            return item.dim_name_en;\n                                        }),\n                                        xDataCn: data.map(function(item) {\n                                            return item.dim_name_cn;\n                                        }),\n                                        lineData: data.map(function(item) {\n                                            return Number(item.volatility_contribution);\n                                        }),\n                                        barData: data.map(function(item) {\n                                            return Number(item.dau_wow_rate);\n                                        }),\n                                        firstCompareData: data.map(function(item) {\n                                            return Number(item.avg_dau);\n                                        }),\n                                        secondCompareData: data.map(function(item) {\n                                            return Number(item.last_avg_dau);\n                                        }),\n                                        tableData: tableData,\nrawData: data\n                                     };\n                                }"
                  },
                  "children": [
                    {
                      "name": "ChangeAnalysisCountryRegionChart",
                      "className": "margin-t-20",
                      "style": {
                        "minHeight": "972px"
                      },
                      "props": {
                        "aiTag": "key_region_trend",
                        "selectConfig": {
                          "searchable": false,
                          "titleEn": "Sort By",
                          "titleCn": "Sort By",
                          "defaultValue": "avg_dau",
                          "listWidth": 217,
                          "selectOptions": [
                            {
                              "value": "avg_dau",
                              "enName": "DAU",
                              "cnName": "DAU",
                              "topInfo": {
                                "sortKey": "dau_wow_rate",
                                "symbolSize": [
                                  40,
                                  30
                                ],
                                "marks": [
                                  {
                                    "label": "变化率\nTOP1"
                                  },
                                  {
                                    "label": "变化率\nTOP2"
                                  }
                                ]
                              }
                            },
                            {
                              "value": "volatility_contribution",
                              "enName": "全球波动贡献",
                              "cnName": "全球波动贡献",
                              "topInfo": {
                                "sortKey": "avg_dau",
                                "symbolSize": [
                                  40,
                                  30
                                ],
                                "marks": [
                                  {
                                    "label": "DAU\nTOP1"
                                  },
                                  {
                                    "label": "DAU\nTOP2"
                                  }
                                ]
                              }
                            },
                            {
                              "value": "dau_wow_rate",
                              "enName": "DAU环比变化率",
                              "cnName": "DAU环比变化率",
                              "topInfo": {
                                "symbolSize": [
                                  40,
                                  30
                                ],
                                "sortKey": "avg_dau",
                                "marks": [
                                  {
                                    "label": "DAU\nTOP1"
                                  },
                                  {
                                    "label": "DAU\nTOP2"
                                  }
                                ]
                              }
                            }
                          ]
                        },
                        "barLineChartConfig": {
                          "titleEn": "非简中重点区域日均DAU环比波动贡献",
                          "titleCn": "非简中重点区域日均DAU环比波动贡献",
                          "barMetricConfig": {
                            "enName": "DAU环比变化率",
                            "cnName": "DAU环比变化率",
                            "metricKey": "dau_wow_rate",
                            "color": "#69D19C",
                            "formatRule": "percent1Decimal",
                            "yAxisFormat": "percentInt",
                            "icon": "greenRedCircle"
                          },
                          "lineMetricConfig": {
                            "enName": "全球波动贡献(%)",
                            "cnName": "全球波动贡献(%)",
                            "metricKey": "volatility_contribution",
                            "color": "#FF9D9D",
                            "formatRule": "percent1Decimal",
                            "yAxisFormat": "percentInt",
                            "seriesConfig": {
                              "lineStyle": {
                                "color": "#F8D74D"
                              }
                            }
                          },
                          "colorArr": [
                            "#69D19C",
                            "#F8D74D"
                          ]
                        },
                        "doubleBarChartConfig": {
                          "titleEn": "非简中重点区域变化（环比上周）",
                          "titleCn": "非简中重点区域变化（环比上周）",
                          "firstBarConfig": {
                            "enName": "本周日均DAU",
                            "cnName": "本周日均DAU",
                            "formatRule": "thousandsInit",
                            "yAxisFormat": "bmk",
                            "firstLabelOffset": {
                              "align": "left"
                            },
                            "lastLabelOffset": {
                              "align": "right"
                            }
                          },
                          "secondBarConfig": {
                            "enName": "上周日均DAU",
                            "cnName": "上周日均DAU",
                            "formatRule": "thousandsInit"
                          }
                        },
                        "tableConfig": {
                          "titleEn": "非简中重点区域日均DAU环比波动贡献",
                          "titleCn": "非简中重点区域日均DAU环比波动贡献",
                          "tableConfig": {
                            "isShowPagination": false,
                            "tableHeight": 834
                          },
                          "columns": [
                            {
                              "nameEn": "区域",
                              "nameCn": "区域",
                              "code": "region",
                              "align": "left",
                              "lock": true
                            },
                            {
                              "nameEn": "本周日均DAU",
                              "nameCn": "本周日均DAU",
                              "code": "avg_dau",
                              "align": "right",
                              "features": {
                                "format": "thousandsInit",
                                "downLoadFormat": "#,##0"
                              }
                            },
                            {
                              "nameEn": "上周日均DAU",
                              "nameCn": "上周日均DAU",
                              "code": "last_avg_dau",
                              "align": "right",
                              "features": {
                                "format": "thousandsInit",
                                "downLoadFormat": "#,##0"
                              }
                            },
                            {
                              "nameEn": "DAU环比变化率",
                              "nameCn": "DAU环比变化率",
                              "code": "dau_wow_rate",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.0%"
                              }
                            },
                            {
                              "nameEn": "全球波动贡献(%)",
                              "nameCn": "全球波动贡献(%)",
                              "code": "volatility_contribution",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.0%"
                              }
                            }
                          ]
                        }
                      }
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "extraParams": {
                      "page_size": 30,
                      "sorted_by": "avg_dau"
                    }
                  },
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/dimension/metrics_trend",
                    "trackData": [
                      "extraParams",
                      "gameCode"
                    ],
                    "dataKey": "trendData",
                    "rawData": true,
                    "beforeRequest": "function(data) {\n                                            var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                            return Object.assign({\n                                                game_code: data.gameCode,\n                                                start_date: start_date,\n                                                end_date: end_date,\n                                                accumulation: {\n                                                    by_country: true\n                                                }\n                                            }, data.extraParams);\n                                        }",
                    "formatData": "function(data) {\n                                            if (!Array.isArray(data)) return {};\n                                            var tableData = data === null || data === void 0 ? void 0 : data.map(function(item) {\n                                                return Object.assign({\n                                                    countryCode: item === null || item === void 0 ? void 0 : item.dim_code,\n                                                    countryNameEn: item.dim_name_en,\n                                                    countryNameCn: item.dim_name_cn\n                                                }, item);\n                                            });\n                                            return {\n                                                countryCode: data.map(function(item) {\n                                                    return item.dim_code;\n                                                }),\n                                                xData: data.map(function(item) {\n                                                    return item.dim_name_en;\n                                                }),\n                                                xDataCn: data.map(function(item) {\n                                                    return item.dim_name_cn;\n                                                }),\n                                                lineData: data.map(function(item) {\n                                                    return Number(item.volatility_contribution);\n                                                }),\n                                                barData: data.map(function(item) {\n                                                    return Number(item.dau_wow_rate);\n                                                }),\n                                                firstCompareData: data.map(function(item) {\n                                                    return Number(item.avg_dau);\n                                                }),\n                                                secondCompareData: data.map(function(item) {\n                                                    return Number(item.last_avg_dau);\n                                                }),\n                                                tableData: tableData,\n                                                rawData: data\n                                            };\n                                        }"
                  },
                  "children": [
                    {
                      "name": "ChangeAnalysisCountryRegionChart",
                      "className": "margin-t-20",
                      "style": {
                        "minHeight": "700px"
                      },
                      "props": {
                        "aiTag": "key_country_trend",
                        "tableCountryJumpLink": "/dashboard/game/{{gameCode}}/dauByRegion?region={{countryCode}}&rangeDateKey=rangeWeekly&start={{filter.start_date}}&end={{filter.end_date}}&defaultTab=dau",
                        "tabOption": {
                          "defaultValue": 30,
                          "tabOptions": [
                            {
                              "value": 30,
                              "enName": "Top 30",
                              "cnName": "Top 30"
                            },
                            {
                              "value": 10,
                              "enName": "Top 10",
                              "cnName": "Top 10"
                            }
                          ],
                          "sheetExtraOptions": [
                            {
                              "value": 0,
                              "enName": "All",
                              "cnName": "All"
                            }
                          ]
                        },
                        "selectConfig": {
                          "searchable": false,
                          "titleEn": "Sort By",
                          "titleCn": "Sort By",
                          "defaultValue": "avg_dau",
                          "listWidth": 217,
                          "selectOptions": [
                            {
                              "value": "avg_dau",
                              "enName": "DAU",
                              "cnName": "DAU",
                              "topInfo": {
                                "sortKey": "dau_wow_rate",
                                "symbolSize": [
                                  40,
                                  30
                                ],
                                "marks": [
                                  {
                                    "label": "变化率\nTOP1"
                                  },
                                  {
                                    "label": "变化率\nTOP2"
                                  }
                                ]
                              }
                            },
                            {
                              "value": "volatility_contribution",
                              "enName": "全球波动贡献",
                              "cnName": "全球波动贡献",
                              "topInfo": {
                                "sortKey": "avg_dau",
                                "symbolSize": [
                                  40,
                                  30
                                ],
                                "marks": [
                                  {
                                    "label": "DAU\nTOP1"
                                  },
                                  {
                                    "label": "DAU\nTOP2"
                                  }
                                ]
                              }
                            },
                            {
                              "value": "dau_wow_rate",
                              "enName": "DAU环比变化率",
                              "cnName": "DAU环比变化率",
                              "topInfo": {
                                "symbolSize": [
                                  40,
                                  30
                                ],
                                "sortKey": "avg_dau",
                                "marks": [
                                  {
                                    "label": "DAU\nTOP1"
                                  },
                                  {
                                    "label": "DAU\nTOP2"
                                  }
                                ]
                              }
                            }
                          ]
                        },
                        "barLineChartConfig": {
                          "titleEn": "非简中重点国家日均DAU环比波动贡献",
                          "titleCn": "非简中重点国家日均DAU环比波动贡献",
                          "showCountryFlag": true,
                          "jumpLink": "/dashboard/game/{{gameCode}}/dauByRegion?region={{regionCode}}&rangeDateKey=rangeWeekly&start={{filter.start_date}}&end={{filter.end_date}}",
                          "barMetricConfig": {
                            "enName": "DAU环比变化率",
                            "cnName": "DAU环比变化率",
                            "metricKey": "dau_wow_rate",
                            "color": "#69D19C",
                            "formatRule": "percent1Decimal",
                            "yAxisFormat": "percentInt",
                            "icon": "greenRedCircle"
                          },
                          "lineMetricConfig": {
                            "enName": "全球波动贡献(%)",
                            "cnName": "全球波动贡献(%)",
                            "metricKey": "volatility_contribution",
                            "formatRule": "percent1Decimal",
                            "yAxisFormat": "percentInt",
                            "seriesConfig": {
                              "lineStyle": {
                                "color": "#F8D74D"
                              }
                            }
                          },
                          "colorArr": [
                            "#69D19C",
                            "#F8D74D"
                          ]
                        },
                        "doubleBarChartConfig": {
                          "titleEn": "非简中重点国家变化（环比上周）",
                          "titleCn": "非简中重点国家变化（环比上周）",
                          "jumpLink": "/dashboard/game/{{gameCode}}/dauByRegion?region={{regionCode}}&rangeDateKey=rangeWeekly&start={{start_date}}&end={{end_date}}",
                          "showCountryFlag": true,
                          "firstBarConfig": {
                            "enName": "本周日均DAU",
                            "cnName": "本周日均DAU",
                            "formatRule": "thousandsInit",
                            "yAxisFormat": "bmk",
                            "firstLabelOffset": {
                              "align": "left"
                            },
                            "lastLabelOffset": {
                              "align": "right"
                            }
                          },
                          "secondBarConfig": {
                            "enName": "上周日均DAU",
                            "cnName": "上周日均DAU",
                            "formatRule": "thousandsInit"
                          }
                        },
                        "tableConfig": {
                          "titleEn": "非简中重点国家日均DAU环比波动贡献",
                          "titleCn": "非简中重点国家日均DAU环比波动贡献",
                          "tableConfig": {
                            "isShowPagination": false,
                            "tableHeight": 834
                          },
                          "columns": [
                            {
                              "nameEn": "国家",
                              "nameCn": "国家",
                              "width": 160,
                              "code": "country",
                              "align": "left",
                              "features": {
                                "cell": {
                                  "type": "country"
                                }
                              }
                            },
                            {
                              "nameEn": "本周日均DAU",
                              "nameCn": "本周日均DAU",
                              "code": "avg_dau",
                              "width": 107,
                              "align": "right",
                              "features": {
                                "format": "thousandsInit",
                                "downLoadFormat": "#,##0"
                              }
                            },
                            {
                              "nameEn": "上周日均DAU",
                              "nameCn": "上周日均DAU",
                              "code": "last_avg_dau",
                              "width": 107,
                              "align": "right",
                              "features": {
                                "format": "thousandsInit",
                                "downLoadFormat": "#,##0"
                              }
                            },
                            {
                              "nameEn": "DAU环比变化率",
                              "nameCn": "DAU环比变化率",
                              "code": "dau_wow_rate",
                              "width": 115,
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.0%"
                              }
                            },
                            {
                              "nameEn": "全球波动贡献(%)",
                              "nameCn": "全球波动贡献(%)",
                              "code": "volatility_contribution",
                              "width": 115,
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.0%"
                              }
                            },
                            {
                              "nameEn": "今年趋势",
                              "nameCn": "今年趋势",
                              "code": "this_year_trend",
                              "width": 110,
                              "align": "left",
                              "features": {
                                "format": "thousandsInit",
                                "cell": {
                                  "type": "mapping",
                                  "valueMapping": {
                                    "0": {
                                      "label": "下降",
                                      "labelCn": "下降",
                                      "status": "down"
                                    },
                                    "1": {
                                      "label": "上升",
                                      "labelCn": "上升",
                                      "status": "up"
                                    }
                                  }
                                }
                              }
                            },
                            {
                              "nameEn": "和去年趋势是否一致",
                              "nameCn": "和去年趋势是否一致",
                              "code": "same_with_last_year",
                              "width": 125,
                              "align": "left",
                              "features": {
                                "format": "thousandsInit",
                                "cell": {
                                  "type": "mapping",
                                  "valueMapping": {
                                    "0": {
                                      "label": "否",
                                      "labelCn": "否"
                                    },
                                    "1": {
                                      "label": "是",
                                      "labelCn": "是"
                                    }
                                  }
                                }
                              }
                            },
                            {
                              "nameEn": "和去年同期差距",
                              "nameCn": "和去年同期差距",
                              "code": "gap_with_last_year",
                              "width": 107,
                              "align": "left",
                              "features": {
                                "format": "thousandsInit",
                                "cell": {
                                  "type": "mapping",
                                  "valueMapping": {
                                    "0": {
                                      "label": "负增长",
                                      "labelCn": "负增长"
                                    },
                                    "1": {
                                      "label": "正增长",
                                      "labelCn": "正增长"
                                    }
                                  }
                                }
                              }
                            },
                            {
                              "nameEn": "关注程度",
                              "nameCn": "关注程度",
                              "width": 110,
                              "code": "highlight",
                              "align": "left",
                              "features": {
                                "format": "thousandsInit",
                                "cell": {
                                  "type": "mapping",
                                  "valueMapping": {
                                    "0": {
                                      "label": "高",
                                      "labelCn": "低"
                                    },
                                    "1": {
                                      "label": "高",
                                      "labelCn": "高"
                                    }
                                  }
                                }
                              }
                            }
                          ]
                        }
                      }
                    }
                  ]
                },
                {
                  "name": "Service",
                  "data": {
                    "abnormalAttributionFilter": {
                      "filters": {
                        "dim_list": [
                          "汇总"
                        ]
                      }
                    },
                    "extraParams": {
                      "multi_sort": [
                        {
                          "sort_by": "change_percentage",
                          "desc": true
                        }
                      ],
                      "page": 1,
                      "page_size": 10
                    }
                  },
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/overall_guiyin",
                    "trackData": [
                      "extraParams",
                      "gameCode",
                      "abnormalAttributionFilter"
                    ],
                    "dataKey": "tableData",
                    "beforeRequest": "function(data) {\n                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                    return Object.assign({\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date,\n                                        period: period\n                                    }, data.extraParams, data.abnormalAttributionFilter);\n                                }"
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/overall_guiyin_dims",
                        "trackData": [
                          "gameCode"
                        ],
                        "dataKey": "optionData",
                        "beforeRequest": "function(data) {\n                                            var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                            return Object.assign({\n                                                game_code: data.gameCode,\n                                                start_date: start_date,\n                                                end_date: end_date,\n                                                period: period\n                                            });\n                                        }",
                        "formatData": "function(data) {\n                                            if (!Array.isArray(data === null || data === void 0 ? void 0 : data.list)) return {};\n                                            return data === null || data === void 0 ? void 0 : data.list;\n                                        }"
                      },
                      "children": [
                        {
                          "name": "Service",
                          "props": {
                            "api": "/api/v1/dashboard/weekly_analysis/overall_guiyin/ai",
                            "trackData": [
                              "gameCode"
                            ],
                            "dataKey": "aiData",
                            "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        period: period,\n                                                        logical_flag: ''\n                                                    }, data.extraParams);\n                                                }"
                          },
                          "children": [
                            {
                              "data": {
                                "abnormalAttributionData": {
                                  "metrics": [],
                                  "metrics_map": {}
                                }
                              },
                              "name": "ChangeAnalysisAbnormalAttributionTable",
                              "className": "margin-t-20",
                              "dataKey": "tableData.data.list",
                              "props": {
                                "metricsCardWrapProps": {
                                  "titleEn": "非简中异动归因关键因素分析",
                                  "titleCn": "非简中异动归因关键因素分析",
                                  "contentHeaderPrefix": "关键发现：{{aiData.data.content}}",
                                  "operation": [
                                    {
                                      "name": "DownloadButton",
                                      "className": "dbd-common-table__operation-btn",
                                      "config": {
                                        "backendDownload": {
                                          "fileNameEn": "非简中异动归因关键因素分析",
                                          "fileNameCn": "非简中异动归因关键因素分析",
                                          "api": "/api/v1/dashboard/weekly_analysis/overall_guiyin/download",
                                          "beforeRequest": "function(data) {\n                                                                                var _data_abnormalAttributionFilter;\n                                                                                var _data_filter;\n                                                                                var _ref = (_data_filter = data === null || data === void 0 ? void 0 : data.filter) !== null && _data_filter !== void 0 ? _data_filter : {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                                                                return Object.assign({\n                                                                                    game_code: data.gameCode,\n                                                                                    start_date: start_date,\n                                                                                    end_date: end_date,\n                                                                                    period: period,\n                                                                                    logical_flag: '',\n                                                                                    filters: (data === null || data === void 0 ? void 0 : (_data_abnormalAttributionFilter = data.abnormalAttributionFilter) === null || _data_abnormalAttributionFilter === void 0 ? void 0 : _data_abnormalAttributionFilter.filters) || [\n                                                                                        '汇总'\n                                                                                    ]\n                                                                                }, data.extraParams, data.abnormalAttributionData);\n                                                                            }"
                                        }
                                      }
                                    }
                                  ]
                                },
                                "commonBaseTableProps": {
                                  "height": 600,
                                  "columns": [
                                    {
                                      "nameEn": "维度",
                                      "nameCn": "维度",
                                      "code": "dims",
                                      "align": "left"
                                    },
                                    {
                                      "nameEn": "分类",
                                      "nameCn": "分类",
                                      "code": "features",
                                      "align": "left"
                                    },
                                    {
                                      "nameEn": "本周周日均DAU",
                                      "nameCn": "本周周日均DAU",
                                      "code": "week_average_dau",
                                      "align": "right",
                                      "features": {
                                        "format": "thousandsInit"
                                      }
                                    },
                                    {
                                      "nameEn": "上周周日均DAU",
                                      "nameCn": "上周周日均DAU",
                                      "code": "compared_week_dau",
                                      "align": "right",
                                      "features": {
                                        "format": "thousandsInit"
                                      }
                                    },
                                    {
                                      "nameEn": "变化量",
                                      "nameCn": "变化量",
                                      "code": "change_amount",
                                      "align": "right",
                                      "features": {
                                        "format": "thousandsInit"
                                      }
                                    },
                                    {
                                      "nameEn": "变化率",
                                      "nameCn": "变化率",
                                      "code": "change_percentage",
                                      "align": "right",
                                      "features": {
                                        "format": "percent1Decimal",
                                        "cell": {
                                          "showPercentageAsChangeRate": true,
                                          "showProgressBar": true,
                                          "showNegativeSign": false,
                                          "progressBarProps": {
                                            "mode": "center"
                                          }
                                        }
                                      }
                                    }
                                  ],
                                  "tableConfig": {}
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "Service",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/metrics_trend",
                    "trackData": [
                      "extraParams",
                      "gameCode"
                    ],
                    "dataKey": "retentionTrendData",
                    "rawData": true,
                    "beforeRequest": "function(data) {\n                                            var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                            return Object.assign({\n                                                game_code: data.gameCode,\n                                                start_date: start_date,\n                                                end_date: end_date,\n                                                period: period,\n                                                logical_flag: \"last_3_month\",\n                                                metrics: [\n                                                    \"active_ret_d2\",\n                                                    \"active_ret_d30\"\n                                                ]\n                                            }, data.extraParams);\n                                        }",
                    "formatData": "function(data) {\n                                            return data;\n                                        }"
                  },
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/metrics_trend",
                        "trackData": [
                          "extraParams",
                          "gameCode"
                        ],
                        "dataKey": "newReturnTrendData",
                        "rawData": true,
                        "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        period: period,\n                                                        logical_flag: \"last_3_month\",\n                                                        metrics: [\n                                                            \"new_ret_d2\",\n                                                            \"return_ret_d2\"\n                                                        ]\n                                                    }, data.extraParams);\n                                                }",
                        "formatData": "function(data) {\n                                                    return data;\n                                                }"
                      },
                      "children": [
                        {
                          "name": "Service",
                          "props": {
                            "api": "/api/v1/dashboard/weekly_analysis/metrics_trend",
                            "trackData": [
                              "extraParams",
                              "gameCode"
                            ],
                            "dataKey": "onlineDayTrendData",
                            "rawData": true,
                            "formatRules": [
                              {
                                "keys": [
                                  "avg_online_day_trend_data.value",
                                  "avg_online_day_trend_data.last_year_data",
                                  "avg_online_day_trend_data.last_year_version_data"
                                ],
                                "format": "oneDecimal"
                              }
                            ],
                            "beforeRequest": "function(data) {\n                                                            var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                                            return Object.assign({\n                                                                game_code: data.gameCode,\n                                                                start_date: start_date,\n                                                                end_date: end_date,\n                                                                period: period,\n                                                                logical_flag: \"last_3_month\",\n                                                                metrics: [\n                                                                    \"avg_online_day\"\n                                                                ]\n                                                            }, data.extraParams);\n                                                        }",
                            "formatData": "function(data) {\n                                                            return data;\n                                                        }"
                          },
                          "children": [
                            {
                              "name": "Service",
                              "props": {
                                "api": "/api/v1/dashboard/weekly_analysis/metrics_trend",
                                "trackData": [
                                  "extraParams",
                                  "gameCode"
                                ],
                                "dataKey": "onlineTimeTrendData",
                                "rawData": true,
                                "beforeRequest": "function(data) {\n                                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date, period = _ref.period;\n                                                                    return Object.assign({\n                                                                        game_code: data.gameCode,\n                                                                        start_date: start_date,\n                                                                        end_date: end_date,\n                                                                        period: period,\n                                                                        logical_flag: \"last_3_month\",\n                                                                        metrics: [\n                                                                            \"avg_onlinetime_min\"\n                                                                        ]\n                                                                    }, data.extraParams);\n                                                                }",
                                "formatData": "function(data) {\n                                                                    return data;\n                                                                }"
                              },
                              "children": [
                                {
                                  "name": "ChangeAnalysisMultiTrendPanel",
                                  "className": "margin-t-20",
                                  "props": {
                                    "titleEn": "用户质量分析",
                                    "titleCn": "用户质量分析",
                                    "eventKey": "eventData",
                                    "showEventSwitch": true,
                                    "defaultShowEvent": true,
                                    "downloadFileName": "用户质量分析",
                                    "fullscreenScale": 1.3,
                                    "fullscreenXAxisScale": 1.6,
                                    "radioConfig": {
                                      "targetSeriesIndex": 1,
                                      "defaultValue": "version_aligned",
                                      "options": [
                                        {
                                          "value": "version_aligned",
                                          "labelCn": "版本周对齐",
                                          "labelEn": "版本周对齐",
                                          "metricKey": "last_year_version_dau",
                                          "dateKey": "last_year_version_date",
                                          "eventDataKey": "eventData"
                                        },
                                        {
                                          "value": "natural_day_aligned",
                                          "labelCn": "自然日对齐",
                                          "labelEn": "自然日对齐",
                                          "metricKey": "last_year_dau",
                                          "dateKey": "last_year_date",
                                          "eventDataKey": "lastEventData"
                                        }
                                      ]
                                    },
                                    "trendCharts": [
                                      {
                                        "titleCn": "非简中活跃留存同比趋势",
                                        "titleEn": "非简中活跃留存同比趋势",
                                        "apiDataKey": "retentionTrendData",
                                        "trendDataKeys": [
                                          "active_ret_d2_trend_data",
                                          "active_ret_d30_trend_data"
                                        ],
                                        "aiTag": "weekly_active_retention_trend",
                                        "enableAlignmentAiDataKey": true,
                                        "enableFullScreen": true,
                                        "seriesConfig": [
                                          {
                                            "metricKey": "active_ret_d2",
                                            "cnName": "活跃次留",
                                            "enName": "活跃次留",
                                            "color": "#5086F3",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "date"
                                          },
                                          {
                                            "metricKey": "last_year_version_active_ret_d2",
                                            "cnName": "活跃次留（去年版本同期）",
                                            "enName": "活跃次留（去年版本同期）",
                                            "color": "#5086F3",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "last_year_version_date",
                                            "lineStyle": {
                                              "type": "dotted"
                                            }
                                          },
                                          {
                                            "metricKey": "active_ret_d30",
                                            "cnName": "活跃30留",
                                            "enName": "活跃30留",
                                            "color": "#69D19C",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "date"
                                          },
                                          {
                                            "metricKey": "last_year_version_active_ret_d30",
                                            "cnName": "活跃30留（去年版本同期）",
                                            "enName": "活跃30留（去年版本同期）",
                                            "color": "#69D19C",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "last_year_version_date",
                                            "lineStyle": {
                                              "type": "dotted"
                                            }
                                          }
                                        ],
                                        "radioConfig": {
                                          "targetSeriesIndexes": [
                                            1,
                                            3
                                          ],
                                          "defaultValue": "version_aligned",
                                          "options": [
                                            {
                                              "value": "version_aligned",
                                              "eventDataKey": "eventData",
                                              "replacements": [
                                                {
                                                  "metricKey": "last_year_version_active_ret_d2",
                                                  "dateKey": "last_year_version_date",
                                                  "cnName": "活跃次留（去年版本同期）",
                                                  "enName": "活跃次留（去年版本同期）"
                                                },
                                                {
                                                  "metricKey": "last_year_version_active_ret_d30",
                                                  "dateKey": "last_year_version_date",
                                                  "cnName": "活跃30留（去年版本同期）",
                                                  "enName": "活跃30留（去年版本同期）"
                                                }
                                              ]
                                            },
                                            {
                                              "value": "natural_day_aligned",
                                              "eventDataKey": "lastEventData",
                                              "replacements": [
                                                {
                                                  "metricKey": "last_year_active_ret_d2",
                                                  "dateKey": "last_year_date",
                                                  "cnName": "活跃次留（去年同期）",
                                                  "enName": "活跃次留（去年同期）"
                                                },
                                                {
                                                  "metricKey": "last_year_active_ret_d30",
                                                  "dateKey": "last_year_date",
                                                  "cnName": "活跃30留（去年同期）",
                                                  "enName": "活跃30留（去年同期）"
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        "chartConfig": {
                                          "yAxisFormat": "percentInt",
                                          "formatRule": "percent2Decimal",
                                          "dateFormatRule": "MM-DD",
                                          "grid": {
                                            "top": 105
                                          }
                                        },
                                        "downloadConfig": {
                                          "columns": [
                                            {
                                              "code": "date",
                                              "name": "日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date"
                                            },
                                            {
                                              "code": "active_ret_d2",
                                              "name": "活跃次留",
                                              "format": "0.00%"
                                            },
                                            {
                                              "code": "active_ret_d30",
                                              "name": "活跃30留",
                                              "format": "0.00%"
                                            },
                                            {
                                              "code": "event",
                                              "dependKey": "date",
                                              "dateKey": "start_time",
                                              "name": "事件开始时间",
                                              "format": "@",
                                              "type": "event"
                                            },
                                            {
                                              "code": "last_year_version_date",
                                              "name": "去年版本同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_active_ret_d2",
                                              "name": "活跃次留（去年版本同期）",
                                              "format": "0.00%",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_active_ret_d30",
                                              "name": "活跃30留（去年版本同期）",
                                              "format": "0.00%",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_event",
                                              "dependKey": "last_year_version_date",
                                              "dateKey": "start_time",
                                              "name": "去年版本同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_date",
                                              "name": "去年同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_active_ret_d2",
                                              "name": "活跃次留（去年同期）",
                                              "format": "0.00%",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_active_ret_d30",
                                              "name": "活跃30留（去年同期）",
                                              "format": "0.00%",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_event",
                                              "dependKey": "last_year_date",
                                              "dateKey": "start_time",
                                              "name": "去年同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "natural_day_aligned"
                                            }
                                          ]
                                        }
                                      },
                                      {
                                        "titleCn": "非简中新进回流留存同比趋势",
                                        "titleEn": "非简中新进回流留存同比趋势",
                                        "apiDataKey": "newReturnTrendData",
                                        "trendDataKeys": [
                                          "new_ret_d2_trend_data",
                                          "return_ret_d2_trend_data"
                                        ],
                                        "aiTag": "weekly_new_return_retention_trend",
                                        "enableAlignmentAiDataKey": true,
                                        "enableFullScreen": true,
                                        "seriesConfig": [
                                          {
                                            "metricKey": "new_ret_d2",
                                            "cnName": "新进次留",
                                            "enName": "新进次留",
                                            "color": "#5086F3",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "date"
                                          },
                                          {
                                            "metricKey": "last_year_version_new_ret_d2",
                                            "cnName": "新进次留（去年版本同期）",
                                            "enName": "新进次留（去年版本同期）",
                                            "color": "#5086F3",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "last_year_version_date",
                                            "lineStyle": {
                                              "type": "dotted"
                                            }
                                          },
                                          {
                                            "metricKey": "return_ret_d2",
                                            "cnName": "回流次留",
                                            "enName": "回流次留",
                                            "color": "#69D19C",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "date"
                                          },
                                          {
                                            "metricKey": "last_year_version_return_ret_d2",
                                            "cnName": "回流次留（去年版本同期）",
                                            "enName": "回流次留（去年版本同期）",
                                            "color": "#69D19C",
                                            "formatRule": "percent2Decimal",
                                            "dateKey": "last_year_version_date",
                                            "lineStyle": {
                                              "type": "dotted"
                                            }
                                          }
                                        ],
                                        "radioConfig": {
                                          "targetSeriesIndexes": [
                                            1,
                                            3
                                          ],
                                          "defaultValue": "version_aligned",
                                          "options": [
                                            {
                                              "value": "version_aligned",
                                              "eventDataKey": "eventData",
                                              "replacements": [
                                                {
                                                  "metricKey": "last_year_version_new_ret_d2",
                                                  "dateKey": "last_year_version_date",
                                                  "cnName": "新进次留（去年版本同期）",
                                                  "enName": "新进次留（去年版本同期）"
                                                },
                                                {
                                                  "metricKey": "last_year_version_return_ret_d2",
                                                  "dateKey": "last_year_version_date",
                                                  "cnName": "回流次留（去年版本同期）",
                                                  "enName": "回流次留（去年版本同期）"
                                                }
                                              ]
                                            },
                                            {
                                              "value": "natural_day_aligned",
                                              "eventDataKey": "lastEventData",
                                              "replacements": [
                                                {
                                                  "metricKey": "last_year_new_ret_d2",
                                                  "dateKey": "last_year_date",
                                                  "cnName": "新进次留（去年同期）",
                                                  "enName": "新进次留（去年同期）"
                                                },
                                                {
                                                  "metricKey": "last_year_return_ret_d2",
                                                  "dateKey": "last_year_date",
                                                  "cnName": "回流次留（去年同期）",
                                                  "enName": "回流次留（去年同期）"
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        "chartConfig": {
                                          "yAxisFormat": "percentInt",
                                          "formatRule": "percent2Decimal",
                                          "dateFormatRule": "MM-DD",
                                          "grid": {
                                            "top": 105
                                          }
                                        },
                                        "downloadConfig": {
                                          "columns": [
                                            {
                                              "code": "date",
                                              "name": "日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date"
                                            },
                                            {
                                              "code": "new_ret_d2",
                                              "name": "新进次留",
                                              "format": "0.00%"
                                            },
                                            {
                                              "code": "return_ret_d2",
                                              "name": "回流次留",
                                              "format": "0.00%"
                                            },
                                            {
                                              "code": "event",
                                              "dependKey": "date",
                                              "dateKey": "start_time",
                                              "name": "事件开始时间",
                                              "format": "@",
                                              "type": "event"
                                            },
                                            {
                                              "code": "last_year_version_date",
                                              "name": "去年版本同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_new_ret_d2",
                                              "name": "新进次留（去年版本同期）",
                                              "format": "0.00%",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_return_ret_d2",
                                              "name": "回流次留（去年版本同期）",
                                              "format": "0.00%",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_event",
                                              "dependKey": "last_year_version_date",
                                              "dateKey": "start_time",
                                              "name": "去年版本同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_date",
                                              "name": "去年同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_new_ret_d2",
                                              "name": "新进次留（去年同期）",
                                              "format": "0.00%",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_return_ret_d2",
                                              "name": "回流次留（去年同期）",
                                              "format": "0.00%",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_event",
                                              "dependKey": "last_year_date",
                                              "dateKey": "start_time",
                                              "name": "去年同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "natural_day_aligned"
                                            }
                                          ]
                                        }
                                      },
                                      {
                                        "titleCn": "周平均活跃天数同比趋势",
                                        "titleEn": "周平均活跃天数同比趋势",
                                        "apiDataKey": "onlineDayTrendData",
                                        "trendDataKeys": [
                                          "avg_online_day_trend_data"
                                        ],
                                        "aiTag": "weekly_avg_online_day_trend",
                                        "enableAlignmentAiDataKey": true,
                                        "enableFullScreen": true,
                                        "weeklyEventMerge": true,
                                        "seriesConfig": [
                                          {
                                            "metricKey": "avg_online_day",
                                            "cnName": "周平均活跃天数",
                                            "enName": "周平均活跃天数",
                                            "color": "#5086F3",
                                            "formatRule": "thousands1Decimal",
                                            "dateKey": "date"
                                          },
                                          {
                                            "metricKey": "last_year_version_avg_online_day",
                                            "cnName": "周平均活跃天数（去年版本同期）",
                                            "enName": "周平均活跃天数（去年版本同期）",
                                            "color": "#69D19C",
                                            "formatRule": "thousands1Decimal",
                                            "dateKey": "last_year_version_date",
                                            "lineStyle": {
                                              "type": "dotted"
                                            }
                                          }
                                        ],
                                        "radioConfig": {
                                          "targetSeriesIndex": 1,
                                          "defaultValue": "version_aligned",
                                          "options": [
                                            {
                                              "value": "version_aligned",
                                              "metricKey": "last_year_version_avg_online_day",
                                              "dateKey": "last_year_version_date",
                                              "cnName": "周平均活跃天数（去年版本同期）",
                                              "enName": "周平均活跃天数（去年版本同期）",
                                              "eventDataKey": "eventData"
                                            },
                                            {
                                              "value": "natural_day_aligned",
                                              "metricKey": "last_year_avg_online_day",
                                              "dateKey": "last_year_date",
                                              "cnName": "周平均活跃天数（去年同期）",
                                              "enName": "周平均活跃天数（去年同期）",
                                              "eventDataKey": "lastEventData"
                                            }
                                          ]
                                        },
                                        "yAxisMin": {
                                          "enabled": false,
                                          "min": 0
                                        },
                                        "chartConfig": {
                                          "yAxisFormat": "thousandsInit",
                                          "formatRule": "thousands1Decimal",
                                          "dateFormatRule": "MM-DD",
                                          "grid": {
                                            "top": 105
                                          },
                                          "interval": 2
                                        },
                                        "downloadConfig": {
                                          "columns": [
                                            {
                                              "code": "date",
                                              "name": "日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date"
                                            },
                                            {
                                              "code": "avg_online_day",
                                              "name": "周平均活跃天数",
                                              "format": "#,##0.0"
                                            },
                                            {
                                              "code": "event",
                                              "dependKey": "date",
                                              "dateKey": "start_time",
                                              "name": "事件开始时间",
                                              "format": "@",
                                              "type": "event"
                                            },
                                            {
                                              "code": "last_year_version_date",
                                              "name": "去年版本同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_avg_online_day",
                                              "name": "周平均活跃天数（去年版本同期）",
                                              "format": "#,##0.0",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_event",
                                              "dependKey": "last_year_version_date",
                                              "dateKey": "start_time",
                                              "name": "去年版本同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_date",
                                              "name": "去年同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_avg_online_day",
                                              "name": "周平均活跃天数（去年同期）",
                                              "format": "#,##0.0",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_event",
                                              "dependKey": "last_year_date",
                                              "dateKey": "start_time",
                                              "name": "去年同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "natural_day_aligned"
                                            }
                                          ]
                                        }
                                      },
                                      {
                                        "titleCn": "周日平均在线时长同比趋势",
                                        "titleEn": "周日平均在线时长同比趋势",
                                        "apiDataKey": "onlineTimeTrendData",
                                        "trendDataKeys": [
                                          "avg_onlinetime_min_trend_data"
                                        ],
                                        "aiTag": "weekly_avg_onlinetime_min_trend",
                                        "enableAlignmentAiDataKey": true,
                                        "enableFullScreen": true,
                                        "weeklyEventMerge": true,
                                        "seriesConfig": [
                                          {
                                            "metricKey": "avg_onlinetime_min",
                                            "cnName": "周日平均在线时长",
                                            "enName": "周日平均在线时长",
                                            "color": "#5086F3",
                                            "formatRule": "thousands2Decimal",
                                            "dateKey": "date"
                                          },
                                          {
                                            "metricKey": "last_year_version_avg_onlinetime_min",
                                            "cnName": "周日平均在线时长（去年版本同期）",
                                            "enName": "周日平均在线时长（去年版本同期）",
                                            "color": "#69D19C",
                                            "formatRule": "thousands2Decimal",
                                            "dateKey": "last_year_version_date",
                                            "lineStyle": {
                                              "type": "dotted"
                                            }
                                          }
                                        ],
                                        "radioConfig": {
                                          "targetSeriesIndex": 1,
                                          "defaultValue": "version_aligned",
                                          "options": [
                                            {
                                              "value": "version_aligned",
                                              "metricKey": "last_year_version_avg_onlinetime_min",
                                              "dateKey": "last_year_version_date",
                                              "cnName": "周日平均在线时长（去年版本同期）",
                                              "enName": "周日平均在线时长（去年版本同期）",
                                              "eventDataKey": "eventData"
                                            },
                                            {
                                              "value": "natural_day_aligned",
                                              "metricKey": "last_year_avg_onlinetime_min",
                                              "dateKey": "last_year_date",
                                              "cnName": "周日平均在线时长（去年同期）",
                                              "enName": "周日平均在线时长（去年同期）",
                                              "eventDataKey": "lastEventData"
                                            }
                                          ]
                                        },
                                        "chartConfig": {
                                          "yAxisFormat": "thousandsInit",
                                          "formatRule": "thousands2Decimal",
                                          "dateFormatRule": "MM-DD",
                                          "grid": {
                                            "top": 105
                                          }
                                        },
                                        "downloadConfig": {
                                          "columns": [
                                            {
                                              "code": "date",
                                              "name": "日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date"
                                            },
                                            {
                                              "code": "avg_onlinetime_min",
                                              "name": "周日平均在线时长",
                                              "format": "#,##0.00"
                                            },
                                            {
                                              "code": "event",
                                              "dependKey": "date",
                                              "dateKey": "start_time",
                                              "name": "事件开始时间",
                                              "format": "@",
                                              "type": "event"
                                            },
                                            {
                                              "code": "last_year_version_date",
                                              "name": "去年版本同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_avg_onlinetime_min",
                                              "name": "周日平均在线时长（去年版本同期）",
                                              "format": "#,##0.00",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_version_event",
                                              "dependKey": "last_year_version_date",
                                              "dateKey": "start_time",
                                              "name": "去年版本同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "version_aligned"
                                            },
                                            {
                                              "code": "last_year_date",
                                              "name": "去年同期日期",
                                              "format": "yyyy-mm-dd",
                                              "type": "date",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_avg_onlinetime_min",
                                              "name": "周日平均在线时长（去年同期）",
                                              "format": "#,##0.00",
                                              "radioValue": "natural_day_aligned"
                                            },
                                            {
                                              "code": "last_year_event",
                                              "dependKey": "last_year_date",
                                              "dateKey": "start_time",
                                              "name": "去年同期事件开始时间",
                                              "format": "@",
                                              "type": "event",
                                              "radioValue": "natural_day_aligned"
                                            }
                                          ]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "Service",
              "data": {
                "extraParams": {
                  "page_size": 30,
                  "metrics": [
                    "prev_active_retention"
                  ]
                }
              },
              "props": {
                "api": "/api/v1/dashboard/weekly_analysis/dimension/metrics_trend",
                "trackData": [
                  "extraParams",
                  "gameCode"
                ],
                "dataKey": "trendData",
                "rawData": true,
                "beforeRequest": "function(data) {\n                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                    return Object.assign({\n                                        game_code: data.gameCode,\n                                        start_date: start_date,\n                                        end_date: end_date,\n                                        accumulation: {\n                                            by_country: true\n                                        }\n                                    }, data.extraParams);\n                                }",
                "formatData": "function(data) {\n                                    if (!Array.isArray(data)) return {};\n                                    var tableData = data === null || data === void 0 ? void 0 : data.map(function(item) {\n                                        return Object.assign({\n                                            countryCode: item === null || item === void 0 ? void 0 : item.dim_code,\n                                            countryNameEn: item.dim_name_en,\n                                            countryNameCn: item.dim_name_cn\n                                        }, item);\n                                    });\n                                    return {\n                                        tableData: tableData,\n                                        rawData: data\n                                    };\n                                }"
              },
              "children": [
                {
                  "name": "ViewportFullscreenShell",
                  "className": "margin-t-20",
                  "style": {
                    "minHeight": "700px"
                  },
                  "props": {
                    "enabled": true,
                    "layerClassName": "dbd-change-analysis-country-region-fs-root dbd-change-analysis-country-region-fs-root--active",
                    "backdropClassName": "dbd-change-analysis-country-region-fs-backdrop",
                    "placeholderClassName": "dbd-change-analysis-country-region-chart-fs-placeholder",
                    "placeholderMinHeight": 520,
                    "inlineHostClassName": "dbd-change-analysis-country-region-chart-host"
                  },
                  "children": [
                    {
                      "name": "ChangeAnalysisCountryRegionChart",
                      "props": {
                        "tableOnly": true,
                        "useMetricsParam": true,
                        "enableImageDownload": true,
                        "enableAlignmentAiDataKey": true,
                        "imageExportTableWidth": "2100px",
                        "imageExportRowHeight": 20,
                        "imageExportHeaderFontSize": 14,
                        "imageExportContentFontSize": 18,
                        "imageExportProgressBarHeight": 16,
                        "useMetricTabFileName": true,
                        "alignmentSwitchConfig": {
                          "defaultValue": "version_aligned",
                          "options": [
                            {
                              "value": "version_aligned",
                              "name": "版本周对齐",
                              "nameCn": "版本周对齐"
                            },
                            {
                              "value": "natural_day_aligned",
                              "name": "自然日对齐",
                              "nameCn": "自然日对齐"
                            }
                          ]
                        },
                        "alignmentSwitchHiddenMetrics": [
                          "avg_online_day",
                          "avg_onlinetime_min"
                        ],
                        "tableCountryJumpLink": "/dashboard/game/{{gameCode}}/dauByRegion?region={{countryCode}}&rangeDateKey=rangeWeekly&start={{filter.start_date}}&end={{filter.end_date}}&defaultTab={{selectValue}}",
                        "metricUrlMap": {
                          "prev_active_retention": "active_retention",
                          "prev_new_return_retention": "new_return_retention"
                        },
                        "aiTagMap": {
                          "avg_onlinetime_min": "weekly_country_avg_onlinetime_min",
                          "avg_online_day": "weekly_country_avg_online_day",
                          "prev_active_retention": "weekly_country_active_retention",
                          "prev_new_return_retention": "weekly_country_new_return_retention"
                        },
                        "tabOption": {
                          "defaultValue": 30,
                          "tabOptions": [
                            {
                              "value": 30,
                              "enName": "Top 30",
                              "cnName": "Top 30"
                            },
                            {
                              "value": 10,
                              "enName": "Top 10",
                              "cnName": "Top 10"
                            }
                          ],
                          "sheetExtraOptions": [
                            {
                              "value": 0,
                              "enName": "All",
                              "cnName": "All"
                            }
                          ]
                        },
                        "selectConfig": {
                          "searchable": false,
                          "titleEn": "指标",
                          "titleCn": "指标",
                          "defaultValue": "prev_active_retention",
                          "listWidth": 217,
                          "selectOptions": [
                            {
                              "value": "prev_active_retention",
                              "enName": "活跃留存",
                              "cnName": "活跃留存"
                            },
                            {
                              "value": "prev_new_return_retention",
                              "enName": "新进回流留存",
                              "cnName": "新进回流留存"
                            },
                            {
                              "value": "avg_onlinetime_min",
                              "enName": "周日平均在线时长",
                              "cnName": "周日平均在线时长"
                            },
                            {
                              "value": "avg_online_day",
                              "enName": "周平均活跃天数",
                              "cnName": "周平均活跃天数"
                            }
                          ]
                        },
                        "tableConfig": {
                          "titleEn": "非简中重点国家表现",
                          "titleCn": "非简中重点国家表现",
                          "tableConfig": {
                            "isShowPagination": false,
                            "tableHeight": 834
                          }
                        },
                        "metricsColumnMap": {
                          "avg_onlinetime_min": [
                            {
                              "nameEn": "重点国家",
                              "nameCn": "重点国家",
                              "width": 160,
                              "code": "country",
                              "align": "left",
                              "lock": true,
                              "features": {
                                "cell": {
                                  "type": "country"
                                }
                              }
                            },
                            {
                              "nameEn": "周日平均在线时长",
                              "nameCn": "周日平均在线时长",
                              "code": "avg_onlinetime_min",
                              "align": "right",
                              "features": {
                                "format": "thousands2Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "right"
                                  }
                                },
                                "downLoadFormat": "#,##0.00"
                              }
                            },
                            {
                              "nameEn": "周环比",
                              "nameCn": "周环比",
                              "code": "avg_onlinetime_min_wow",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "年同比",
                              "nameCn": "年同比",
                              "code": "avg_onlinetime_min_yoy",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "版本年同比",
                              "nameCn": "版本年同比",
                              "code": "avg_onlinetime_min_version_yoy",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.00%"
                              }
                            }
                          ],
                          "avg_online_day": [
                            {
                              "nameEn": "重点国家",
                              "nameCn": "重点国家",
                              "width": 160,
                              "code": "country",
                              "align": "left",
                              "lock": true,
                              "features": {
                                "cell": {
                                  "type": "country"
                                }
                              }
                            },
                            {
                              "nameEn": "周平均活跃天数",
                              "nameCn": "周平均活跃天数",
                              "code": "avg_online_day",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "right"
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            },
                            {
                              "nameEn": "周环比",
                              "nameCn": "周环比",
                              "code": "avg_online_day_wow",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "年同比",
                              "nameCn": "年同比",
                              "code": "avg_online_day_yoy",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "版本年同比",
                              "nameCn": "版本年同比",
                              "code": "avg_online_day_version_yoy",
                              "align": "right",
                              "features": {
                                "format": "percent1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center"
                                  }
                                },
                                "downLoadFormat": "0.00%"
                              }
                            }
                          ],
                          "prev_active_retention": [
                            {
                              "nameEn": "重点国家",
                              "nameCn": "重点国家",
                              "width": 160,
                              "code": "country",
                              "align": "left",
                              "lock": true,
                              "features": {
                                "cell": {
                                  "type": "country"
                                }
                              }
                            },
                            {
                              "nameEn": "活跃次留",
                              "nameCn": "活跃次留",
                              "width": 130,
                              "code": "active_ret_d2",
                              "align": "right",
                              "features": {
                                "format": "percent2Decimal",
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "周环比（PP）",
                              "nameCn": "周环比（PP）",
                              "code": "active_ret_d2_wow",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            },
                            {
                              "nameEn": "版本年同比（PP）",
                              "nameCn": "版本年同比（PP）",
                              "code": "active_ret_d2_yoy",
                              "width": 180,
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            },
                            {
                              "nameEn": "活跃30留",
                              "nameCn": "活跃30留",
                              "width": 120,
                              "code": "active_ret_d30",
                              "align": "right",
                              "features": {
                                "format": "percent2Decimal",
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "周环比（PP）",
                              "nameCn": "周环比（PP）",
                              "code": "active_ret_d30_wow",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            },
                            {
                              "nameEn": "版本年同比（PP）",
                              "nameCn": "版本年同比（PP）",
                              "width": 180,
                              "code": "active_ret_d30_yoy",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            }
                          ],
                          "prev_new_return_retention": [
                            {
                              "nameEn": "重点国家",
                              "nameCn": "重点国家",
                              "width": 160,
                              "code": "country",
                              "align": "left",
                              "lock": true,
                              "features": {
                                "cell": {
                                  "type": "country"
                                }
                              }
                            },
                            {
                              "nameEn": "新进次留",
                              "nameCn": "新进次留",
                              "code": "new_ret_d2",
                              "align": "right",
                              "features": {
                                "format": "percent2Decimal",
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "周环比（PP）",
                              "nameCn": "周环比（PP）",
                              "code": "new_ret_d2_wow",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            },
                            {
                              "nameEn": "版本年同比（PP）",
                              "nameCn": "版本年同比（PP）",
                              "width": 180,
                              "code": "new_ret_d2_yoy",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            },
                            {
                              "nameEn": "回流次留",
                              "nameCn": "回流次留",
                              "code": "return_ret_d2",
                              "align": "right",
                              "features": {
                                "format": "percent2Decimal",
                                "downLoadFormat": "0.00%"
                              }
                            },
                            {
                              "nameEn": "周环比（PP）",
                              "nameCn": "周环比（PP）",
                              "code": "return_ret_d2_wow",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            },
                            {
                              "nameEn": "版本年同比（PP）",
                              "nameCn": "版本年同比（PP）",
                              "width": 180,
                              "code": "return_ret_d2_yoy",
                              "align": "right",
                              "features": {
                                "format": "thousands1Decimal",
                                "cell": {
                                  "progressBarProps": {
                                    "mode": "center",
                                    "basedOnColumnRange": true
                                  }
                                },
                                "downLoadFormat": "#,##0.0"
                              }
                            }
                          ]
                        },
                        "alignmentConfig": {
                          "natural_day_aligned": {
                            "metricsColumnMap": {
                              "prev_active_retention": [
                                {
                                  "nameEn": "重点国家",
                                  "nameCn": "重点国家",
                                  "width": 160,
                                  "code": "country",
                                  "align": "left",
                                  "lock": true,
                                  "features": {
                                    "cell": {
                                      "type": "country"
                                    }
                                  }
                                },
                                {
                                  "nameEn": "活跃次留",
                                  "nameCn": "活跃次留",
                                  "code": "active_ret_d2",
                                  "align": "right",
                                  "features": {
                                    "format": "percent2Decimal",
                                    "downLoadFormat": "0.00%"
                                  }
                                },
                                {
                                  "nameEn": "周环比（PP）",
                                  "nameCn": "周环比（PP）",
                                  "code": "active_ret_d2_wow",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                },
                                {
                                  "nameEn": "年同比（PP）",
                                  "nameCn": "年同比（PP）",
                                  "code": "active_ret_d2_natural_yoy",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                },
                                {
                                  "nameEn": "活跃30留",
                                  "nameCn": "活跃30留",
                                  "code": "active_ret_d30",
                                  "align": "right",
                                  "features": {
                                    "format": "percent2Decimal",
                                    "downLoadFormat": "0.00%"
                                  }
                                },
                                {
                                  "nameEn": "周环比（PP）",
                                  "nameCn": "周环比（PP）",
                                  "code": "active_ret_d30_wow",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                },
                                {
                                  "nameEn": "年同比（PP）",
                                  "nameCn": "年同比（PP）",
                                  "code": "active_ret_d30_natural_yoy",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                }
                              ],
                              "prev_new_return_retention": [
                                {
                                  "nameEn": "重点国家",
                                  "nameCn": "重点国家",
                                  "width": 160,
                                  "code": "country",
                                  "align": "left",
                                  "lock": true,
                                  "features": {
                                    "cell": {
                                      "type": "country"
                                    }
                                  }
                                },
                                {
                                  "nameEn": "新进次留",
                                  "nameCn": "新进次留",
                                  "code": "new_ret_d2",
                                  "align": "right",
                                  "features": {
                                    "format": "percent2Decimal",
                                    "downLoadFormat": "0.00%"
                                  }
                                },
                                {
                                  "nameEn": "周环比（PP）",
                                  "nameCn": "周环比（PP）",
                                  "code": "new_ret_d2_wow",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                },
                                {
                                  "nameEn": "年同比（PP）",
                                  "nameCn": "年同比（PP）",
                                  "code": "new_ret_d2_natural_yoy",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                },
                                {
                                  "nameEn": "回流次留",
                                  "nameCn": "回流次留",
                                  "code": "return_ret_d2",
                                  "align": "right",
                                  "features": {
                                    "format": "percent2Decimal",
                                    "downLoadFormat": "0.00%"
                                  }
                                },
                                {
                                  "nameEn": "周环比（PP）",
                                  "nameCn": "周环比（PP）",
                                  "code": "return_ret_d2_wow",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                },
                                {
                                  "nameEn": "年同比（PP）",
                                  "nameCn": "年同比（PP）",
                                  "code": "return_ret_d2_natural_yoy",
                                  "align": "right",
                                  "features": {
                                    "format": "thousands1Decimal",
                                    "cell": {
                                      "progressBarProps": {
                                        "mode": "center",
                                        "basedOnColumnRange": true
                                      }
                                    },
                                    "downLoadFormat": "#,##0.0"
                                  }
                                }
                              ]
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "SegmentScrollCo",
              "className": "dbd-change-analysis-segment-scroll-co",
              "props": {
                "config": {
                  "variant": "floating",
                  "showDownloadBtn": true,
                  "downloadFileNameEn": "非简中异动归因关键因素分析",
                  "downloadFileNameCn": "非简中异动归因关键因素分析",
                  "componentSegment": [
                    {
                      "value": "dbd_change_analysis_public_comment_related_clues",
                      "enName": "公众评论相关性线索",
                      "cnName": "公众评论相关性线索"
                    },
                    {
                      "value": "dbd_change_analysis_competitor_activity",
                      "enName": "竞品活动",
                      "cnName": "竞品活动"
                    },
                    {
                      "value": "dbd_change_analysis_player_comment_cluster",
                      "enName": "玩家评论聚类",
                      "cnName": "玩家评论聚类"
                    },
                    {
                      "value": "dbd_change_analysis_ranking_change",
                      "enName": "排行榜变动",
                      "cnName": "排行榜变动"
                    },
                    {
                      "value": "dbd_change_analysis_historical_similarity_abnormal",
                      "enName": "历史相似异常",
                      "cnName": "历史相似异常"
                    },
                    {
                      "value": "dbd_change_analysis_holiday_impact",
                      "enName": "节假日影响",
                      "cnName": "节假日影响"
                    }
                  ],
                  "scrollMarginTop": 75
                }
              },
              "children": [
                {
                  "name": "SegmentScrollChildrenWrapper",
                  "id": "dbd_change_analysis_public_comment_related_clues",
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/detail",
                        "trackData": [
                          "extraParams",
                          "gameCode"
                        ],
                        "dataKey": "tableData",
                        "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        logical_flag: \"公众评论相关性线索\"\n                                                    }, data.extraParams);\n                                                }",
                        "formatData": "function(data) {\n                                                    try {\n                                                        var _data_;\n                                                        if (!Array.isArray(data)) return {};\n                                                        var infoDetail = JSON.parse(((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.info_detail) || '[]');\n                                                        if (Array.isArray(infoDetail)) {\n                                                            var formattedData = infoDetail.map(function(item) {\n                                                                if (item === null || item === void 0 ? void 0 : item['互动量（赞/转/评）']) {\n                                                                    var parts = item['互动量（赞/转/评）'].split('/');\n                                                                    return Object.assign({}, item, {\n                                                                        '点赞': Number((parts[0] || '0').replace(/,/g, '')) || 0,\n                                                                        '转发': Number((parts[1] || '0').replace(/,/g, '')) || 0,\n                                                                        '评论': Number((parts[2] || '0').replace(/,/g, '')) || 0\n                                                                    });\n                                                                }\n                                                                return item;\n                                                            });\n                                                            return formattedData;\n                                                        }\n                                                        return infoDetail;\n                                                    } catch (error) {\n                                                        console.error('formatData error:', error);\n                                                        return [];\n                                                    }\n                                                }"
                      },
                      "children": [
                        {
                          "name": "CommonTable",
                          "className": "margin-t-20",
                          "props": {
                            "dataKey": "tableData",
                            "metricsCardWrapProps": {
                              "titleEn": "公众评论相关性线索",
                              "titleCn": "公众评论相关性线索",
                              "link": false
                            },
                            "commonBaseTableProps": {
                              "height": 300,
                              "columns": [
                                {
                                  "nameEn": "证据类型",
                                  "nameCn": "证据类型",
                                  "code": "证据类型",
                                  "align": "left",
                                  "lock": true,
                                  "features": {
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "核心内容",
                                  "nameCn": "核心内容",
                                  "code": "核心内容",
                                  "align": "left",
                                  "features": {
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "链接",
                                  "nameCn": "链接",
                                  "code": "链接",
                                  "align": "left",
                                  "downLoadWidth": 500,
                                  "features": {
                                    "cell": {
                                      "type": "markdownLink"
                                    },
                                    "downLoadFormat": "function(value) {\n                                                                            var markdownLinkRegex = /\\[([^\\]]+)\\]\\(([^)]+)\\)/;\n                                                                            var safeValue = typeof value === 'string' ? value : String(value !== null && value !== void 0 ? value : '');\n                                                                            var match = safeValue.match(markdownLinkRegex) || null;\n                                                                            return (match === null || match === void 0 ? void 0 : match[2]) || value;\n                                                                        }"
                                  }
                                },
                                {
                                  "nameEn": "点赞",
                                  "nameCn": "点赞",
                                  "code": "点赞",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                },
                                {
                                  "nameEn": "转发",
                                  "nameCn": "转发",
                                  "code": "转发",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                },
                                {
                                  "nameEn": "评论",
                                  "nameCn": "评论",
                                  "code": "评论",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                }
                              ],
                              "tableConfig": {
                                "pagination": {
                                  "pageSizeVisible": false,
                                  "pageIndexVisible": false,
                                  "jumpVisible": false,
                                  "endJumpVisible": false
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "SegmentScrollChildrenWrapper",
                  "id": "dbd_change_analysis_competitor_activity",
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/detail",
                        "trackData": [
                          "extraParams",
                          "gameCode"
                        ],
                        "dataKey": "tableData",
                        "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        logical_flag: \"竞品活动\"\n                                                    }, data.extraParams);\n                                                }",
                        "formatData": "function(data) {\n                                                    var _data_;\n                                                    if (!Array.isArray(data)) return {};\n                                                    return JSON.parse(((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.info_detail) || '[]');\n                                                }"
                      },
                      "children": [
                        {
                          "name": "CommonTable",
                          "className": "margin-t-20",
                          "props": {
                            "dataKey": "tableData",
                            "metricsCardWrapProps": {
                              "titleEn": "竞品活动",
                              "titleCn": "竞品活动"
                            },
                            "commonBaseTableProps": {
                              "height": 300,
                              "columns": [
                                {
                                  "nameEn": "竞品名称",
                                  "nameCn": "竞品名称",
                                  "code": "竞品名称",
                                  "align": "left",
                                  "lock": true,
                                  "downLoadWidth": 300,
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "行为类型",
                                  "nameCn": "行为类型",
                                  "code": "行为类型",
                                  "align": "left",
                                  "downLoadWidth": 500,
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "关键内容",
                                  "nameCn": "关键内容",
                                  "code": "关键内容",
                                  "align": "left",
                                  "downLoadWidth": 500,
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "时间",
                                  "nameCn": "时间",
                                  "code": "时间",
                                  "align": "left",
                                  "downLoadWidth": 500,
                                  "features": {
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "预期影响",
                                  "nameCn": "预期影响",
                                  "code": "预期影响",
                                  "align": "left",
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                }
                              ],
                              "tableConfig": {
                                "pagination": {
                                  "pageSizeVisible": false,
                                  "pageIndexVisible": false,
                                  "jumpVisible": false,
                                  "endJumpVisible": false
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "SegmentScrollChildrenWrapper",
                  "id": "dbd_change_analysis_player_comment_cluster",
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/detail",
                        "trackData": [
                          "extraParams",
                          "gameCode"
                        ],
                        "dataKey": "tableData",
                        "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        logical_flag: \"玩家评论\"\n                                                    }, data.extraParams);\n                                                }",
                        "formatData": "function(data) {\n                                                    var _data_;\n                                                    if (!Array.isArray(data)) return {};\n                                                    return JSON.parse(((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.info_detail) || '[]');\n                                                }"
                      },
                      "children": [
                        {
                          "name": "CommonTable",
                          "className": "margin-t-20",
                          "props": {
                            "dataKey": "tableData",
                            "metricsCardWrapProps": {
                              "titleEn": "玩家评论聚类",
                              "titleCn": "玩家评论聚类"
                            },
                            "commonBaseTableProps": {
                              "height": 300,
                              "columns": [
                                {
                                  "nameEn": "主题",
                                  "nameCn": "主题",
                                  "code": "主题",
                                  "align": "left",
                                  "lock": true,
                                  "downLoadWidth": 500,
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "评论摘要",
                                  "nameCn": "评论摘要",
                                  "code": "评论摘要",
                                  "align": "left",
                                  "downLoadWidth": 500,
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "关联原因",
                                  "nameCn": "关联原因",
                                  "code": "关联原因",
                                  "align": "left",
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "热度",
                                  "nameCn": "热度",
                                  "code": "热度",
                                  "align": "right",
                                  "features": {
                                    "format": "thousandsInit",
                                    "downLoadFormat": "#,##0"
                                  }
                                }
                              ],
                              "tableConfig": {
                                "pagination": {
                                  "pageSizeVisible": false,
                                  "pageIndexVisible": false,
                                  "jumpVisible": false,
                                  "endJumpVisible": false
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "SegmentScrollChildrenWrapper",
                  "id": "dbd_change_analysis_ranking_change",
                  "children": [
                    {
                      "name": "Service",
                      "data": {
                        "rankingChangeTable": {
                          "platform": "appStore"
                        },
                        "platformDimMap": {
                          "googlePlay": [
                            "googleplay top free",
                            "googleplay top grossing"
                          ],
                          "appStore": [
                            "appstore top free",
                            "appstore top grossing"
                          ]
                        }
                      },
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/overall_rank",
                        "trackData": [
                          "extraParams",
                          "gameCode",
                          "rankingChangeTable",
                          "platformDimMap"
                        ],
                        "dataKey": "rankingChangeTableData",
                        "rawData": true,
                        "beforeRequest": "function(data) {\n                                                    var _ref = data || {}, _ref_filterVal = _ref.filterVal, filterVal = _ref_filterVal === void 0 ? {} : _ref_filterVal, gameCode = _ref.gameCode, extraParams = _ref.extraParams, rankingChangeTable = _ref.rankingChangeTable, platformDimMap = _ref.platformDimMap;\n                                                    var _ref1 = filterVal || {}, start_date = _ref1.start_date, end_date = _ref1.end_date, period = _ref1.period;\n                                                    var platform = (rankingChangeTable || {}).platform;\n                                                    var dimList = platformDimMap[platform] || platformDimMap.googlePlay;\n                                                    return Object.assign({\n                                                        game_code: gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        period: period || 'weekly',\n                                                        filters: {\n                                                            dim_list: dimList\n                                                        }\n                                                    }, extraParams || {});\n                                                }",
                        "formatData": "function(data) {\n                                                    var list = (data === null || data === void 0 ? void 0 : data.list) || [];\n                                                    var formatDate = function(str) {\n                                                        if (!str) return '';\n                                                        return \"\".concat(str.slice(0, 4), \"-\").concat(str.slice(4, 6), \"-\").concat(str.slice(6, 8));\n                                                    };\n                                                    list.forEach(function(item) {\n                                                        item.date = formatDate(item.date);\n                                                        item.week_start = formatDate(item.week_start);\n                                                        item.week_end = formatDate(item.week_end);\n                                                        item.base_date = formatDate(item.base_date);\n                                                        item.compare_date = formatDate(item.compare_date);\n                                                    });\n                                                    return list;\n                                                }"
                      },
                      "children": [
                        {
                          "name": "RankingChangeTable",
                          "className": "margin-t-20",
                          "props": {
                            "dataKey": "rankingChangeTableData",
                            "config": {
                              "defaultSegment": "appStore",
                              "gameNameMap": {
                                "PUBG MOBILE": "PUBGM",
                                "Free Fire": "Free Fire",
                                "Blood Strike": "Blood Strike",
                                "Call of Duty: Mobile": "Call of Duty: Mobile",
                                "Delta Force": "Delta Force Mobile",
                                "Roblox": "ROBLOX"
                              },
                              "aiConfig": [
                                {
                                  "tag": "country_change_rank_table",
                                  "dataKey": "rankingChangeTableData"
                                }
                              ],
                              "metricsCardWrapProps": {
                                "titleEn": "排行榜变动",
                                "titleCn": "排行榜变动"
                              },
                              "commonBaseTableProps": {
                                "height": 670,
                                "columns": [
                                  {
                                    "nameEn": "国家",
                                    "nameCn": "国家",
                                    "code": "country",
                                    "width": 150,
                                    "lock": true,
                                    "features": {
                                      "sortable": false,
                                      "cell": {
                                        "type": "country"
                                      }
                                    }
                                  },
                                  {
                                    "nameEn": "PUBGM",
                                    "nameCn": "PUBGM",
                                    "code": "PUBGM",
                                    "features": {
                                      "sortable": false
                                    },
                                    "title": [
                                      {
                                        "name": "RankingChangeTableHeader",
                                        "props": {
                                          "url": "/v2/intelligence/topCharts/mobileGames/gamesDetails/ufc454d9b1af70b40588e2a6fa4da4a8b/storeRank",
                                          "gameIcon": "https://ogdb-cdn.intlgame.cn/pic_by_handle/pubg.png"
                                        }
                                      }
                                    ],
                                    "children": [
                                      {
                                        "nameEn": "免费榜",
                                        "nameCn": "免费榜",
                                        "width": 115,
                                        "code": "PUBGM_免费榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "PUBGM_免费榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "PUBGM_免费榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      },
                                      {
                                        "nameEn": "畅销榜",
                                        "nameCn": "畅销榜",
                                        "width": 115,
                                        "code": "PUBGM_畅销榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "PUBGM_畅销榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "PUBGM_畅销榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      }
                                    ]
                                  },
                                  {
                                    "nameEn": "Free Fire",
                                    "nameCn": "Free Fire",
                                    "code": "Free Fire",
                                    "features": {
                                      "sortable": false
                                    },
                                    "title": [
                                      {
                                        "name": "RankingChangeTableHeader",
                                        "props": {
                                          "url": "/v2/intelligence/topCharts/mobileGames/gamesDetails/u589791f804845507e85fa880c6d88d41/storeRank",
                                          "gameIcon": "https://ogdb-cdn.intlgame.cn/image/7e2465d39f344c0cff3af1d77ceea8ab.jpg"
                                        }
                                      }
                                    ],
                                    "children": [
                                      {
                                        "nameEn": "免费榜",
                                        "nameCn": "免费榜",
                                        "width": 115,
                                        "code": "Free Fire_免费榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Free Fire_免费榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Free Fire_免费榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      },
                                      {
                                        "nameEn": "畅销榜",
                                        "nameCn": "畅销榜",
                                        "width": 115,
                                        "code": "Free Fire_畅销榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Free Fire_畅销榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Free Fire_畅销榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      }
                                    ]
                                  },
                                  {
                                    "nameEn": "Blood Strike",
                                    "nameCn": "Blood Strike",
                                    "code": "Blood Strike",
                                    "features": {
                                      "sortable": false
                                    },
                                    "title": [
                                      {
                                        "name": "RankingChangeTableHeader",
                                        "props": {
                                          "url": "/v2/intelligence/topCharts/mobileGames/gamesDetails/u750cf049827897e3f426182e6a969c89/storeRank",
                                          "gameIcon": "https://ogdb-cdn.intlgame.cn/image/cc958316bdb2f3754fbbb526057dd1ce.jpg"
                                        }
                                      }
                                    ],
                                    "children": [
                                      {
                                        "nameEn": "免费榜",
                                        "nameCn": "免费榜",
                                        "width": 115,
                                        "code": "Blood Strike_免费榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Blood Strike_免费榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Blood Strike_免费榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      },
                                      {
                                        "nameEn": "畅销榜",
                                        "nameCn": "畅销榜",
                                        "width": 115,
                                        "code": "Blood Strike_畅销榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Blood Strike_畅销榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Blood Strike_畅销榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      }
                                    ]
                                  },
                                  {
                                    "nameEn": "Call of Duty: Mobile",
                                    "nameCn": "Call of Duty: Mobile",
                                    "code": "Call of Duty: Mobile",
                                    "features": {
                                      "sortable": false
                                    },
                                    "title": [
                                      {
                                        "name": "RankingChangeTableHeader",
                                        "props": {
                                          "url": "/v2/intelligence/topCharts/mobileGames/gamesDetails/uef76e8182c79db6aafefdfbdd04b7d99/storeRank",
                                          "gameIcon": "https://ogdb-cdn.intlgame.cn/image/87fea3d535b1e52f5bb1f4ad21e099ed.jpg"
                                        }
                                      }
                                    ],
                                    "children": [
                                      {
                                        "nameEn": "免费榜",
                                        "nameCn": "免费榜",
                                        "width": 115,
                                        "code": "Call of Duty: Mobile_免费榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Call of Duty: Mobile_免费榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Call of Duty: Mobile_免费榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      },
                                      {
                                        "nameEn": "畅销榜",
                                        "nameCn": "畅销榜",
                                        "width": 115,
                                        "code": "Call of Duty: Mobile_畅销榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Call of Duty: Mobile_畅销榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Call of Duty: Mobile_畅销榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      }
                                    ]
                                  },
                                  {
                                    "nameEn": "Delta Force Mobile",
                                    "nameCn": "Delta Force Mobile",
                                    "code": "Delta Force Mobile",
                                    "features": {
                                      "sortable": false
                                    },
                                    "title": [
                                      {
                                        "name": "RankingChangeTableHeader",
                                        "props": {
                                          "url": "/v2/intelligence/topCharts/mobileGames/gamesDetails/u10000000082/storeRank",
                                          "gameIcon": "https://ogdb-cdn.intlgame.cn/image/54d5160577e0b50c15ca8ed3a37f5998.jpg"
                                        }
                                      }
                                    ],
                                    "children": [
                                      {
                                        "nameEn": "免费榜",
                                        "nameCn": "免费榜",
                                        "width": 115,
                                        "code": "Delta Force Mobile_免费榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Delta Force Mobile_免费榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Delta Force Mobile_免费榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      },
                                      {
                                        "nameEn": "畅销榜",
                                        "nameCn": "畅销榜",
                                        "width": 115,
                                        "code": "Delta Force Mobile_畅销榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "Delta Force Mobile_畅销榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "Delta Force Mobile_畅销榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      }
                                    ]
                                  },
                                  {
                                    "nameEn": "ROBLOX",
                                    "nameCn": "ROBLOX",
                                    "code": "ROBLOX",
                                    "features": {
                                      "sortable": false
                                    },
                                    "title": [
                                      {
                                        "name": "RankingChangeTableHeader",
                                        "props": {
                                          "url": "/v2/intelligence/topCharts/mobileGames/gamesDetails/u080032403b0f3d7ce099ec68649d222a/storeRank",
                                          "gameIcon": "https://ogdb-cdn.intlgame.cn/image/3d251d9d8d81405481156cecc7bb64eb.jpg"
                                        }
                                      }
                                    ],
                                    "children": [
                                      {
                                        "nameEn": "免费榜",
                                        "nameCn": "免费榜",
                                        "width": 115,
                                        "code": "ROBLOX_免费榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "ROBLOX_免费榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "ROBLOX_免费榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      },
                                      {
                                        "nameEn": "畅销榜",
                                        "nameCn": "畅销榜",
                                        "width": 115,
                                        "code": "ROBLOX_畅销榜",
                                        "align": "center",
                                        "features": {
                                          "revertSort": true,
                                          "cell": {
                                            "type": "trend",
                                            "changeKey": "ROBLOX_畅销榜_data.compareChange",
                                            "showChangeRate": true,
                                            "showNegativeSign": false,
                                            "bubble": {
                                              "contentKey": "ROBLOX_畅销榜_data",
                                              "content": [
                                                {
                                                  "name": "RankingChangeTableChangeBubble"
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        "downloadFormat": "@"
                                      }
                                    ]
                                  }
                                ],
                                "tableConfig": {
                                  "isOpenForegroundPage": true
                                },
                                "featConfig": {
                                  "columnResize": {
                                    "minSize": 100
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "SegmentScrollChildrenWrapper",
                  "id": "dbd_change_analysis_historical_similarity_abnormal",
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/detail",
                        "trackData": [
                          "extraParams",
                          "gameCode"
                        ],
                        "dataKey": "tableData",
                        "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        logical_flag: \"历史相似异常\"\n                                                    }, data.extraParams);\n                                                }",
                        "formatData": "function(data) {\n                                                    var _data_;\n                                                    if (!Array.isArray(data)) return {};\n                                                    return JSON.parse(((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.info_detail) || '[]');\n                                                }"
                      },
                      "children": [
                        {
                          "name": "CommonTable",
                          "className": "margin-t-20",
                          "props": {
                            "dataKey": "tableData",
                            "metricsCardWrapProps": {
                              "titleEn": "历史相似异常",
                              "titleCn": "历史相似异常"
                            },
                            "commonBaseTableProps": {
                              "height": 300,
                              "columns": [
                                {
                                  "nameEn": "异常类型",
                                  "nameCn": "异常类型",
                                  "code": "异常类型",
                                  "width": 330,
                                  "align": "left",
                                  "lock": true,
                                  "features": {
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "内容摘要",
                                  "nameCn": "内容摘要",
                                  "code": "内容摘要",
                                  "width": 750,
                                  "downLoadWidth": 1000,
                                  "align": "left",
                                  "features": {
                                    "downloadFormat": "@"
                                  }
                                }
                              ],
                              "tableConfig": {
                                "isShowPagination": false
                              },
                              "featConfig": {
                                "sortable": false
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "SegmentScrollChildrenWrapper",
                  "id": "dbd_change_analysis_holiday_impact",
                  "children": [
                    {
                      "name": "Service",
                      "props": {
                        "api": "/api/v1/dashboard/weekly_analysis/detail",
                        "trackData": [
                          "extraParams",
                          "gameCode"
                        ],
                        "dataKey": "tableData",
                        "beforeRequest": "function(data) {\n                                                    var _ref = (data === null || data === void 0 ? void 0 : data.filterVal) || {}, start_date = _ref.start_date, end_date = _ref.end_date;\n                                                    return Object.assign({\n                                                        game_code: data.gameCode,\n                                                        start_date: start_date,\n                                                        end_date: end_date,\n                                                        logical_flag: \"节假日影响\"\n                                                    }, data.extraParams);\n                                                }",
                        "formatData": "function(data) {\n                                                    var _data_;\n                                                    if (!Array.isArray(data)) return {};\n                                                    return JSON.parse(((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.info_detail) || '[]');\n                                                }"
                      },
                      "children": [
                        {
                          "name": "CommonTable",
                          "className": "margin-t-20",
                          "props": {
                            "dataKey": "tableData",
                            "metricsCardWrapProps": {
                              "titleEn": "节假日影响",
                              "titleCn": "节假日影响"
                            },
                            "commonBaseTableProps": {
                              "height": 300,
                              "columns": [
                                {
                                  "nameEn": "节日日期",
                                  "nameCn": "节日日期",
                                  "code": "日期",
                                  "align": "left",
                                  "lock": true,
                                  "features": {
                                    "cell": {
                                      "type": "date"
                                    },
                                    "format": "day",
                                    "downLoadFormat": "yyyy-mm-dd"
                                  }
                                },
                                {
                                  "nameEn": "国家",
                                  "nameCn": "国家",
                                  "code": "国家",
                                  "width": 330,
                                  "align": "left",
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "节日名称",
                                  "nameCn": "节日名称",
                                  "code": "节假日事件",
                                  "width": 300,
                                  "downLoadWidth": 500,
                                  "align": "left",
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                },
                                {
                                  "nameEn": "节日类型",
                                  "nameCn": "节日类型",
                                  "code": "节日类型",
                                  "width": 300,
                                  "downLoadWidth": 500,
                                  "align": "left",
                                  "features": {
                                    "sortable": false,
                                    "downloadFormat": "@"
                                  }
                                }
                              ],
                              "tableConfig": {
                                "isShowPagination": false
                              },
                              "featConfig": {}
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
